import React, { useState, useEffect, useCallback, useRef } from 'react';
import negocioService               from '../../services/negocio.service';
import clienteService                from '../../services/cliente.service';
import colaboradorService            from '../../services/colaborador.service';
import clienteParticipanteService    from '../../services/clienteParticipante.service';
import negocioAnexoService           from '../../services/negocioAnexo.service';
import negocioEventoService          from '../../services/negocioEvento.service';
import negocioCallService            from '../../services/negocioCall.service';
import negocioQuantificacaoService   from '../../services/negocioQuantificacao.service';
import crmAcaoService                 from '../../services/crmAcao.service';
import BtnIcone from '../../components/BtnIcone';
import SePode from '../../components/SePode';   // r88
import Modal    from '../../components/Modal';
import Timeline from '../../components/Timeline';
import CallsModal from '../../components/CallsModal';
import QuantificacaoModal from '../../components/QuantificacaoModal';
import AlterarEtapaModal from '../../components/AlterarEtapaModal';
import FecharNegocioModal      from '../../components/FecharNegocioModal';
import PrevisaoFinanceiraModal from '../../components/PrevisaoFinanceiraModal';
import AcoesModal              from '../../components/AcoesModal';
import DefinirDataOportunidadeModal from '../../components/DefinirDataOportunidadeModal';
import BrowseHeader from '../../components/BrowseHeader';                    // r110
import ComboboxInline from '../../components/ComboboxInline';                // r-now: consulta rica (modelo TarefaModal)
import { iconeDaRotina } from '../../constants/iconesRotinas';               // r110

// ─── Constantes visuais ───────────────────────────────────────────────────────
const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  amarelo:  '#d97706',
  amlBg:    '#fffbeb',
  cinzaBg:  '#fafafa',
};

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '14px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  fontFamily: "'Manrope', sans-serif",
};

const inputDisabledStyle = {
  ...inputStyle, backgroundColor: COR.cinzaBg, color: COR.muted,
};

const selectStyle = { ...inputStyle, cursor: 'pointer' };

const textareaStyle = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '14px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto,
  outline: 'none', resize: 'vertical', minHeight: '80px',
  fontFamily: "'Manrope', sans-serif",
};

// ─── Domínios ────────────────────────────────────────────────────────────────
const TIPOS = [
  { v: 'P', l: 'Projeto'      },
  { v: 'U', l: 'Pontual'      },
  { v: 'S', l: 'Service Desk' },
  { v: 'T', l: 'Sustentação'  },
];

const ETAPAS_COM = [
  { v: 'O', l: 'Oportunidade', cor: '#6b7280', dt: 'dt_oportunidade' },
  { v: 'L', l: 'Levantamento', cor: '#0891b2', dt: 'dt_levantamento' },
  { v: 'P', l: 'Proposta',     cor: '#d97706', dt: 'dt_proposta'     },
  { v: 'A', l: 'Aprovação',    cor: '#7c3aed', dt: 'dt_aprovacao'    },
  { v: 'F', l: 'Fechado',      cor: '#1D9E75', dt: 'dt_fechamento'   },
  { v: 'E', l: 'Encerrado',    cor: '#059669', dt: 'dt_encerramento' },
  { v: 'D', l: 'Perdido',      cor: '#e53935', dt: 'dt_perda'        },
];

// ETAPAS TÉCNICAS — armazenadas como STRING completa em negocios.etapa_tecnica
// (não como letra). A ordem aqui também é a ordem do fluxo técnico.
// Cores escolhidas pra evitar conflito com as etapas comerciais:
//   Planejamento     → cinza (início, neutro)
//   Execução         → azul claro (em movimento)
//   Qualidade        → roxo (verificação)
//   Validação Cliente→ laranja (aguardando)
//   Acompanhamento   → teal (pós-entrega)
//   Encerrado        → verde escuro (final)
const ETAPAS_TEC = [
  { v: 'Planejamento',      l: 'Planejamento',      cor: '#6b7280', bg: '#f3f4f6' },
  { v: 'Execução',          l: 'Execução',          cor: '#0ea5e9', bg: '#e0f2fe' },
  { v: 'Qualidade',         l: 'Qualidade',         cor: '#a855f7', bg: '#f3e8ff' },
  { v: 'Validação Cliente', l: 'Validação Cliente', cor: '#f59e0b', bg: '#fef3c7' },
  { v: 'Acompanhamento',    l: 'Acompanhamento',    cor: '#06b6d4', bg: '#cffafe' },
  { v: 'Encerrado',         l: 'Encerrado',         cor: '#059669', bg: '#d1fae5' },
];

const TEMPERATURAS = [
  { v: 'Q', l: 'Quente', icone: '🔥', cor: '#e53935', bg: '#fff0f0' },
  { v: 'M', l: 'Morno',  icone: '🍃', cor: '#1D9E75', bg: '#f0fff4' },
  { v: 'F', l: 'Frio',   icone: '❄️', cor: '#0891b2', bg: '#eff6ff' },
];

const FORMATO_ID = /^[A-Z]{3}-\d{4}$/;

// ─── Helpers ──────────────────────────────────────────────────────────────────
const labelTipo   = (v) => TIPOS.find(t => t.v === v)?.l   || v;
const labelEtTec  = (v) => ETAPAS_TEC.find(e => e.v === v)?.l || '';
const etapaCom    = (v) => ETAPAS_COM.find(e => e.v === v) || ETAPAS_COM[0];
const etapaTec    = (v) => ETAPAS_TEC.find(e => e.v === v); // pode retornar undefined
const temperatura = (v) => TEMPERATURAS.find(t => t.v === v) || TEMPERATURAS[2];
const formatBRL   = (v) => v != null && v !== ''
  ? parseFloat(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  : '—';
const hojeISO     = () => new Date().toISOString().slice(0, 10);

// ── Dias desde dt_ultima_acao até hoje. Retorna null se não tiver data. ──
const diasDesdeUltimaAcao = (dataISO) => {
  if (!dataISO) return null;
  const m = String(dataISO).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const dt = new Date(parseInt(m[1]), parseInt(m[2]) - 1, parseInt(m[3]), 12, 0, 0);
  const hoje = new Date(); hoje.setHours(12, 0, 0, 0);
  return Math.max(0, Math.round((hoje.getTime() - dt.getTime()) / 86400000));
};

// ── Cor da pílula "dias desde última ação" por faixa ──
//   verde:    < 7 dias      (acompanhamento OK)
//   amarelo:  7-15 dias     (atenção)
//   vermelho: 15+ dias      (atrasado)
//   cinza:    sem ação registrada
const corDiasUltimaAcao = (dias) => {
  if (dias === null) return { bg: '#f3f4f6', cor: '#6b7280', borda: '#d1d5db' };
  if (dias < 7)      return { bg: '#f0fff4', cor: '#1D9E75', borda: '#1D9E7555' };
  if (dias <= 15)    return { bg: '#fffbeb', cor: '#d97706', borda: '#d9770655' };
  return                    { bg: '#fff0f0', cor: '#e53935', borda: '#e5393555' };
};

function formatBytes(bytes) {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

// Formata número para padrão BR com 2 casas decimais (ex: 50 → "50,00")
function formatarValorBR(v) {
  if (v === '' || v === null || v === undefined) return '';
  let num;
  if (typeof v === 'number') {
    num = v;
  } else {
    const s = String(v);
    // Se tem vírgula, é formato BR ("4.013,75") — remove pontos e troca vírgula
    // por ponto. Se NÃO tem vírgula, é número JS ("4013.75") — usa direto.
    if (s.includes(',')) {
      num = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    } else {
      num = parseFloat(s);
    }
  }
  if (isNaN(num)) return '';
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Máscara calculadora — interpreta o que o usuário digita como CENTAVOS
// e retorna formatado em BR. Ex: "20000" → "200,00", "1500000" → "15.000,00"
function centavosParaBR(input) {
  if (input === '' || input === null || input === undefined) return '';
  // Pega só os dígitos (descarta tudo que não for número)
  const digitos = String(input).replace(/\D/g, '');
  if (!digitos) return '';
  // Interpreta como centavos: divide por 100
  const num = parseInt(digitos, 10) / 100;
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Converte string BR (ex: "1.500,50") pra número ("1500.50")
function numeroParaBackend(v) {
  if (v === '' || v === null || v === undefined) return '';
  const normalizado = String(v).replace(/\./g, '').replace(',', '.');
  const num = parseFloat(normalizado);
  return isNaN(num) ? '' : num;
}

function dataParaInput(v) {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

function sanitizar(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => {
      if (v === null || v === undefined) return [k, ''];
      if (k.startsWith('dt_') && v) return [k, dataParaInput(v)];
      // valor_previsto vem do banco como número (15000.00) e precisa virar "15.000,00"
      if (k === 'valor_previsto' && v !== '' && v !== null) {
        return [k, formatarValorBR(v)];
      }
      return [k, v];
    })
  );
}

// Validação simples de e-mail
const emailValido = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim());

// Retorna emoji e cor do badge baseado no papel do participante
// Recebe o objeto do participante todo, pra também detectar resp_tecnico via
// colaborador_resp_tecnico (vem do JOIN com colaboradores no backend)
function papelInfo(papel, origem, participante = null) {
  // ATENÇÃO à ordem: verifica papel explícito ANTES de origem
  // (resp. técnico é vinculado automaticamente, então origem='A', mas
  //  o papel é 'resp_tecnico', não 'vendedor')
  if (papel === 'resp_tecnico') {
    return { emoji: '🔧', label: 'Resp. Técnico', cor: '#1D9E75', bg: '#f0fff4' };
  }
  if (papel === 'vendedor') {
    return { emoji: '💼', label: 'Vendedor', cor: '#003399', bg: '#eff6ff' };
  }
  if (papel === 'responsavel') {
    return { emoji: '⭐', label: 'Responsável', cor: '#d97706', bg: '#fffbeb' };
  }
  // Sem papel explícito mas origem automática: provavelmente vendedor antigo
  if (origem === 'A') {
    return { emoji: '💼', label: 'Vendedor', cor: '#003399', bg: '#eff6ff' };
  }
  // Resp. Técnico: participante normal mas o colaborador vinculado tem flag
  if (participante && (participante.colaborador_resp_tecnico === true
                    || participante.colaborador_resp_tecnico === 1)) {
    return { emoji: '🔧', label: 'Resp. Técnico', cor: '#1D9E75', bg: '#f0fff4' };
  }
  return null;
}

// ─── Tag colorida do cliente (mesma do ClientesPage) ──────────────────────────
function TagCliente({ tag, cor }) {
  if (!tag) return <span style={{ color: COR.muted, fontSize: '12px' }}>—</span>;
  const bgCor = cor || '#003399';
  const hex = bgCor.replace('#', '');
  const r = parseInt(hex.substr(0,2),16);
  const g = parseInt(hex.substr(2,2),16);
  const b = parseInt(hex.substr(4,2),16);
  const lum = (0.299*r + 0.587*g + 0.114*b) / 255;
  const corTexto = lum > 0.5 ? '#1a1a2e' : '#ffffff';

  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: bgCor, color: corTexto, letterSpacing: '0.3px',
    }}>{tag}</span>
  );
}

function EtapaPill({ etapa }) {
  const e = etapaCom(etapa);
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: e.cor + '22', color: e.cor,
      border: `1px solid ${e.cor}`,           // r110: borda na cor da fonte
    }}>{e.l}</span>
  );
}

function TemperaturaPill({ temp }) {
  const t = temperatura(temp);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: t.bg, color: t.cor,
      border: `1px solid ${t.cor}`,           // r110: borda na cor da fonte
    }}>{t.icone} {t.l}</span>
  );
}

// ─── SVGs (padrão Cliente): ícones de seção, chevron e ícones de botão ───────
const SvgChevron = ({ size = 16, color = 'currentColor', aberto }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       style={{ transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.15s' }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const svgBase = (color) => ({
  fill: 'none', stroke: color, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
});
const SvgIdentificacao = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" />
  </svg>
);
const SvgParticipantes = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const SvgAnexos = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);
const SvgTimeline = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);
const SvgCalendario = ({ size = 15, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const SvgGrafico = ({ size = 15, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);
const SvgRefresh = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...svgBase(color)}>
    <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);
// Botão no cabeçalho azul do Modal (fundo transparente, borda/branco)
const estiloBtnHeader = {
  padding: '8px 14px', border: '1px solid rgba(255,255,255,0.5)', borderRadius: '5px',
  backgroundColor: 'transparent', color: '#fff', fontSize: '13px', fontWeight: '600',
  cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px',
  fontFamily: "'Manrope', sans-serif", whiteSpace: 'nowrap',
};

// Combo de filtro multiselect (Tipo/Etapa/Temperatura) — botão + dropdown de checkboxes.
function FiltroMultiplo({ titulo, opcoes, selecionados, onToggle, onTodos, getV, getL, getIcone, extra }) {
  const [aberto, setAberto] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setAberto(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const total = opcoes.length;
  const n = selecionados.size;
  const resumo = n === 0 ? 'nenhum' : n === total ? 'todos' : String(n);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setAberto(a => !a)} style={{
        height: '36px', padding: '0 10px', border: `1px solid ${COR.borda}`, borderRadius: '5px',
        backgroundColor: COR.branco, color: COR.texto, fontSize: '13px', cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap',
        fontFamily: "'Manrope', sans-serif",
      }}>
        <span style={{ fontWeight: '600' }}>{titulo}</span>
        <span style={{ color: COR.muted }}>{resumo}</span>
        <SvgChevron aberto={aberto} size={13} color={COR.muted} />
      </button>
      {aberto && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, zIndex: 60, marginTop: '4px',
          minWidth: '180px', maxHeight: '300px', overflowY: 'auto',
          backgroundColor: COR.branco, border: `1px solid ${COR.borda}`, borderRadius: '6px',
          boxShadow: '0 4px 14px rgba(0,0,0,0.1)', padding: '6px',
        }}>
          <div onClick={onTodos} title="Marcar/desmarcar todos" style={{
            fontSize: '11px', fontWeight: '700', color: COR.azul, textTransform: 'uppercase',
            letterSpacing: '0.5px', padding: '4px 6px', cursor: 'pointer', userSelect: 'none',
            borderBottom: `1px solid ${COR.borda}`, marginBottom: '4px',
          }}>Todos / nenhum</div>
          {opcoes.map(o => (
            <label key={getV(o)} style={{
              display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px',
              color: COR.texto, padding: '4px 6px', cursor: 'pointer', userSelect: 'none',
            }}>
              <input type="checkbox" checked={selecionados.has(getV(o))}
                onChange={() => onToggle(getV(o))} style={{ cursor: 'pointer' }} />
              {getIcone && getIcone(o)}
              {getL(o)}
            </label>
          ))}
          {extra}
        </div>
      )}
    </div>
  );
}

function Campo({ label, children, obrigatorio, metade, terco, quarto }) {
  let w = '100%';
  if (quarto) w = 'calc(25% - 8px)';
  else if (terco) w = 'calc(33.33% - 7px)';
  else if (metade) w = 'calc(50% - 5px)';
  return (
    <div style={{ marginBottom: '12px', width: w }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '4px' }}>
        {label}{obrigatorio && <span style={{ color: COR.vermelho }}> *</span>}
      </label>
      {children}
    </div>
  );
}

function Linha({ children }) {
  return <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>{children}</div>;
}

// Seção expansível — padrão do Cadastro de Cliente (ícone SVG + chevron).
function Secao({ icone: Icone, titulo, aberta, onToggle, children, fixa }) {
  const estaAberta = fixa ? true : aberta;
  return (
    <div style={{
      border: `1px solid ${COR.borda}`, borderRadius: '6px',
      marginBottom: '12px', overflow: 'visible', backgroundColor: COR.branco,
    }}>
      <div
        onClick={fixa ? undefined : onToggle}
        style={{
          padding: '12px 16px',
          backgroundColor: estaAberta ? COR.azulBg : COR.cinzaBg,
          borderBottom: estaAberta ? `1px solid ${COR.borda}` : 'none',
          cursor: fixa ? 'default' : 'pointer', userSelect: 'none',
          display: 'flex', alignItems: 'center', gap: '10px',
          transition: 'background-color 0.15s',
        }}
      >
        {Icone && (
          <span style={{ display: 'inline-flex', color: estaAberta ? COR.azul : COR.muted }}>
            <Icone size={18} />
          </span>
        )}
        <span style={{
          flex: 1, fontSize: '14px', fontWeight: '700',
          color: estaAberta ? COR.azul : COR.texto,
        }}>
          {titulo}
        </span>
        {!fixa && (
          <span style={{ display: 'inline-flex', color: COR.muted }}>
            <SvgChevron aberto={estaAberta} size={16} />
          </span>
        )}
      </div>
      {estaAberta && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
}

// ─── Mini-menu genérico (etapa + temperatura) ───────────────────────────────
function MenuOpcoes({ aberto, opcoes, valorAtual, onEscolher, onFechar, posicao }) {
  if (!aberto) return null;
  return (
    <>
      <div onClick={onFechar} style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 50, backgroundColor: 'transparent',
      }} />
      <div style={{
        position: 'fixed',
        top: posicao?.top  ?? 0,
        left: posicao?.left ?? 0,
        backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`,
        borderRadius: '6px',
        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
        padding: '4px', zIndex: 51,
        minWidth: '160px',
      }} onClick={e => e.stopPropagation()}>
        {opcoes.map(o => (
          <div
            key={o.v}
            onClick={() => { onEscolher(o.v); onFechar(); }}
            style={{
              padding: '8px 12px', fontSize: '12px', cursor: 'pointer',
              borderRadius: '4px',
              backgroundColor: o.v === valorAtual ? COR.azulBg : 'transparent',
              fontWeight: o.v === valorAtual ? '600' : '400',
              color: o.cor,
              display: 'flex', alignItems: 'center', gap: '8px',
            }}
            onMouseEnter={ev => ev.currentTarget.style.backgroundColor = o.v === valorAtual ? COR.azulBg : '#f5f5f5'}
            onMouseLeave={ev => ev.currentTarget.style.backgroundColor = o.v === valorAtual ? COR.azulBg : 'transparent'}
          >
            {o.icone ? <span style={{ fontSize: '14px' }}>{o.icone}</span>
                     : <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: o.cor }}></span>}
            {o.l}
          </div>
        ))}
      </div>
    </>
  );
}

// ─── Formulário vazio ─────────────────────────────────────────────────────────
const FORM_VAZIO = {
  id: '',
  descricao: '', versao: '01', tipo: '',
  cliente_id: '', cliente_nome: '',
  etapa_comercial: 'O', etapa_tecnica: '',
  dt_oportunidade: '', dt_levantamento: '', dt_proposta: '',
  dt_aprovacao: '', dt_fechamento: '', dt_encerramento: '', dt_perda: '',
  vendedor_id: '', vendedor_nome: '',
  resp_tecnico_id: '',
  escopo: 'O', id_original: '', chamado: '',
  responsavel: '', email_resp: '', funcao_resp: '',
  valor_previsto: '', valor_hora: '', pct_imposto: '',
  pct_custo_oper: '', pct_comissao: '', valor_atual: '',
  observacoes: '',
  temperatura: 'F',
  // Campos de fechamento (preenchidos quando etapa = F ou E)
  empresa_faturamento_id: '', empresa_faturamento_nome: '',
  data_faturamento: '',
  pct_desconto: '', valor_desconto: '',
  valor_imposto: '', valor_custo_oper: '',
  valor_comissao: '',
  valor_acrescimo: '', valor_liquido: '',
  condicao_pagamento_id: '', condicao_pagamento_desc: '',
  dt_ultima_acao: '',
};

// ═══════════════════════════════════════════════════════════════════════════════
function NegociosPage() {
  // ── Listagem ───────────────────────────────────────────────────────────────
  const [negocios, setNegocios]       = useState([]);
  const [carregando, setCarregando]   = useState(true);
  const [busca, setBusca]             = useState('');
  const [ordenacao, setOrdenacao]     = useState({ campo: 'id', dir: 'asc' });

  // ── Filtros do dash ────────────────────────────────────────────────────────
  const [filtroTipos,  setFiltroTipos]  = useState(new Set(TIPOS.map(t => t.v)));
  const [filtroEtapas, setFiltroEtapas] = useState(new Set(ETAPAS_COM.map(e => e.v)));
  // Temperatura: começa com todas selecionadas
  const [filtroTemps, setFiltroTemps]   = useState(new Set(TEMPERATURAS.map(t => t.v)));
  // Filtro "Fechados Período": quando ativo, troca a fonte de dados
  // (chama endpoint dedicado) e desliga o check de etapa "F".
  const [filtroFechadosPeriodo, setFiltroFechadosPeriodo] = useState(false);
  // Mês/ano selecionado pra esse filtro (formato "MM/YYYY"), default mês atual
  const [mesAnoFechadosPeriodo, setMesAnoFechadosPeriodo] = useState(() => {
    const d = new Date();
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  });
  // Abre o popup que pergunta o período quando o filtro é marcado
  const [dialogPeriodoAberto, setDialogPeriodoAberto] = useState(false);
  // Lista de negócios fechados no período (vem do endpoint, fica em cache)
  const [listaFechadosPeriodo, setListaFechadosPeriodo] = useState([]);
  const [carregandoFechados, setCarregandoFechados] = useState(false);

  // ── Mini-menu ──────────────────────────────────────────────────────────────
  const [menuAberto, setMenuAberto] = useState({ tipo: null, negocioId: null, valorAtual: null, posicao: null });

  // ── Painel ──────────────────────────────────────────────────────────────────
  const [painel, setPainel]           = useState(null);
  const [selecionado, setSelecionado] = useState(null);
  const [form, setForm]               = useState(FORM_VAZIO);
  const [salvando, setSalvando]       = useState(false);
  const [erroPainel, setErroPainel]   = useState('');
  const [sucessoPainel, setSucessoPainel] = useState('');
  const [etapaOriginalDoBanco, setEtapaOriginalDoBanco] = useState('');

  // Padrão de seções abertas/fechadas:
  //   - Edição/Visualização: só Identificação + Etapas + Timeline expandidas
  //   - Inclusão (modo novo): tudo expandido (ajustado em abrirPainel)
  const [secoes, setSecoes] = useState({
    identif: true, etapas: true, origem: false, participantes: false,
    anexos: false, valores: false, obs: false, timeline: true,
  });

  // ── Combos ─────────────────────────────────────────────────────────────────
  const [clientes, setClientes]               = useState([]);
  const [vendedores, setVendedores]           = useState([]);
  const [respTecnicos, setRespTecnicos]       = useState([]);
  const [negociosAditivo, setNegociosAditivo] = useState([]);

  // ── Participantes ──────────────────────────────────────────────────────────
  const [participantes, setParticipantes]               = useState([]);
  const [participantesCliente, setParticipantesCliente] = useState([]);
  const [formNovoPart, setFormNovoPart]                 = useState({ nome: '', email: '' });
  const [mostrarFormPart, setMostrarFormPart]           = useState(false);
  const [mostrarSelectExistente, setMostrarSelectExistente] = useState(false);
  const [erroPart, setErroPart]                         = useState('');

  // ── Anexos ─────────────────────────────────────────────────────────────────
  const [anexos, setAnexos]                     = useState([]);
  const [uploadando, setUploadando]             = useState(false);
  const [progressoUpload, setProgressoUpload]   = useState(0);
  const [erroAnexo, setErroAnexo]               = useState('');
  // Estados do mini-form de upload (descrição + exibir na timeline + arquivo)
  const [mostrarFormAnexo, setMostrarFormAnexo] = useState(false);
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [descricaoAnexo, setDescricaoAnexo]     = useState('');
  const [exibirTimeline, setExibirTimeline]     = useState(true);
  const [dataExibicaoAnexo, setDataExibicaoAnexo] = useState('');   // data do anexo na timeline

  // ── Aditivos vinculados (links na Identificação) ───────────────────────────
  const [aditivosVinculados, setAditivosVinculados] = useState([]);

  // ── Timeline (eventos visíveis) ────────────────────────────────────────────
  const [eventosTimeline, setEventosTimeline] = useState([]);

  // ── Modal de Calls ─────────────────────────────────────────────────────────
  const [callsModalAberto, setCallsModalAberto] = useState(false);

  // ── Modal de Quantificação ─────────────────────────────────────────────────
  const [quantifModalAberto, setQuantifModalAberto] = useState(false);
  const [anexoDos010Atual, setAnexoDos010Atual] = useState(null);

  // ── Modal de Alterar Etapa Comercial ───────────────────────────────────────
  const [alterarEtapaModalAberto, setAlterarEtapaModalAberto] = useState(false);
  // Quando aberto vem do fluxo DOS010 → Proposta, pré-seleciona e bloqueia o combo.
  // Quando aberto pelo botão "🔄 Alterar", fica null (combo livre).
  const [etapaPreSelecionadaModal, setEtapaPreSelecionadaModal] = useState(null);
  const [motivoPreModal, setMotivoPreModal] = useState('');
  // Quando o modal é aberto por causa de um anexo recém-incluído (DOS010),
  // guarda o id pra que o backend sincronize a data do evento do anexo com
  // a data escolhida pra etapa.
  const [anexoIdRecenteModal, setAnexoIdRecenteModal] = useState(null);

  // ── Modal de Data da Oportunidade (abre logo após inclusão de novo negócio) ──
  // Sem cancelar/ESC — o usuário precisa informar a data antes de prosseguir.
  // O modal chama definirDataOportunidade que cria o evento na timeline e
  // atualiza dt_oportunidade do negócio com a data escolhida.
  const [dataOportunidadeModalAberto, setDataOportunidadeModalAberto] = useState(false);
  const [negocioRecemIncluido, setNegocioRecemIncluido] = useState(null);

  // ── Modais de Fechamento e Previsão Financeira ─────────────────────────────
  const [fecharModalAberto, setFecharModalAberto] = useState(false);
  const [previsaoModalAberto, setPrevisaoModalAberto] = useState(false);
  // Quando o usuário escolhe avançar pra F no AlterarEtapaModal, NÃO salvamos
  // direto: guardamos data + motivo aqui e abrimos o FecharNegocioModal.
  // Depois que o fechamento for confirmado, chamamos alterarEtapaComMotivo
  // mandando o body com `fechamento` preenchido.
  const [dadosFechamentoEvento, setDadosFechamentoEvento] = useState(null);

  // ── Modal de Alteração de Etapa TÉCNICA ────────────────────────────────────
  // Reusa o AlterarEtapaModal com prop modoTecnico=true.
  const [etapaTecnicaModalAberto, setEtapaTecnicaModalAberto] = useState(false);

  // ── Modal de Ações (CRM) ──────────────────────────────────────────────────
  const [acoesModalAberto, setAcoesModalAberto] = useState(false);
  // Negócio sobre o qual o modal de ações foi aberto (pode ser pela linha do
  // browse, sem precisar entrar no painel principal de edição).
  const [negocioAcoes, setNegocioAcoes] = useState(null);

  // ── Usuário logado (pra auditoria nas criações) ────────────────────────────
  // Objeto completo do usuário (com nome, nomeAmigavel, id) — usado pelos
  // modais que precisam exibir o nome do usuário (ex: AcoesModal).
  const usuarioLogado = (() => {
    try {
      const raw = localStorage.getItem('usuario');
      if (raw) return JSON.parse(raw);
    } catch {}
    return null;
  })();
  const usuarioLogadoId = usuarioLogado?.id || null;

  const secaoLabelStyle = {
    fontSize: '11px', fontWeight: '700', color: COR.azul,
    textTransform: 'uppercase', letterSpacing: '0.5px',
    margin: '16px 0 10px',
  };

  // ═══════ CARREGAMENTOS ═══════════════════════════════════════════════════
  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const lista = await negocioService.listar();
      setNegocios(lista);
    } catch {
      setNegocios([]);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  // ── Carregar negócios fechados no período (via endpoint dedicado) ────────
  // Dispara quando o filtro "Fechados Período" fica ativo OU quando o mês/ano muda.
  const carregarFechadosPeriodo = useCallback(async () => {
    if (!filtroFechadosPeriodo) return;
    const m = String(mesAnoFechadosPeriodo).match(/^(\d{2})\/(\d{4})$/);
    if (!m) return;
    const mes = parseInt(m[1], 10);
    const ano = parseInt(m[2], 10);
    try {
      setCarregandoFechados(true);
      const lista = await negocioService.fechadosNoPeriodo(mes, ano);
      setListaFechadosPeriodo(lista);
    } catch (err) {
      console.error('Erro ao carregar fechados no período:', err);
      setListaFechadosPeriodo([]);
    } finally {
      setCarregandoFechados(false);
    }
  }, [filtroFechadosPeriodo, mesAnoFechadosPeriodo]);

  useEffect(() => { carregarFechadosPeriodo(); }, [carregarFechadosPeriodo]);

  const carregarCombos = useCallback(async () => {
    try {
      // r167d: os combos usavam clienteService.listar() e colaboradorService.listar()
      // (GET /clientes e /colaboradores), que exigem permissão do cadastro E aplicam
      // o filtro "só os meus". Quem monta negócio sem acesso a Clientes/Colaboradores
      // (ou com filtro) tomava 403 / lista vazia — e como era Promise.all, um único
      // 403 zerava os TRÊS combos de uma vez.
      // Agora usa as referências leves (qualquer autenticado, sem filtro de rotina).
      // Vendedor e resp. técnico são filtrados no servidor (?vendedor / ?resp_tecnico).
      const [cli, vend, resp] = await Promise.all([
        clienteService.listarReferencia(),
        colaboradorService.listarReferencia({ vendedor: true }),
        colaboradorService.listarReferencia({ resp_tecnico: true }),
      ]);
      setClientes(cli);
      setVendedores(vend);
      setRespTecnicos(resp);
    } catch (err) {
      console.error('Erro ao carregar combos:', err);
    }
  }, []);

  // Lista aditivos/original vinculados ao negócio atual
  const calcularAditivosVinculados = useCallback((registro, todosNegocios) => {
    if (!registro) return [];
    if (registro.escopo === 'O') {
      // Original: lista os aditivos (negócios que referenciam este)
      return todosNegocios.filter(n => n.id_original === registro.id);
    }
    if (registro.escopo === 'A' && registro.id_original) {
      // Aditivo: mostra o original + outros aditivos-irmãos (excluindo ele mesmo)
      const original = todosNegocios.find(n => n.id === registro.id_original);
      const irmaos = todosNegocios.filter(
        n => n.id_original === registro.id_original && n.id !== registro.id
      );
      return original ? [original, ...irmaos] : irmaos;
    }
    return [];
  }, []);

  // ═══════ FILTRO E ORDENAÇÃO DA LISTA ═════════════════════════════════════
  // Quando o filtro "Fechados Período" está ativo, a fonte vem do endpoint
  // dedicado (negocios fechados que têm parcelas no mês/ano) e o filtro de
  // etapa "F" é ignorado. Caso contrário usa a lista normal.
  const fonteLista = filtroFechadosPeriodo ? listaFechadosPeriodo : negocios;

  const listaFiltrada = fonteLista
    .filter(n => {
      const q = busca.toLowerCase();
      const matchBusca = !q
        || (n.id || '').toLowerCase().includes(q)
        || n.descricao.toLowerCase().includes(q)
        || (n.cliente_nome  || '').toLowerCase().includes(q)
        || (n.vendedor_nome || '').toLowerCase().includes(q)
        || (n.vendedor_nome_amigavel || '').toLowerCase().includes(q);
      const matchTipo  = filtroTipos.has(n.tipo);
      // Se "Fechados Período" ativo, o filtro de etapa fica neutralizado
      // (só mostra negócios em F mesmo).
      const matchEtapa = filtroFechadosPeriodo ? true : filtroEtapas.has(n.etapa_comercial);
      // Filtro temperatura — registros sem temperatura ('') passam só se TODAS
      // as opções estiverem marcadas (default). Caso contrário, filtra estrito.
      const matchTemp  = n.temperatura
        ? filtroTemps.has(n.temperatura)
        : filtroTemps.size === TEMPERATURAS.length;
      return matchBusca && matchTipo && matchEtapa && matchTemp;
    })
    .sort((a, b) => {
      const va = (a[ordenacao.campo] || '').toString().toLowerCase();
      const vb = (b[ordenacao.campo] || '').toString().toLowerCase();
      return ordenacao.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const toggleOrdem = (campo) =>
    setOrdenacao(o => ({ campo, dir: o.campo === campo && o.dir === 'asc' ? 'desc' : 'asc' }));

  const setaCabecalho = (campo) => {
    if (ordenacao.campo !== campo) return ' ↕';
    return ordenacao.dir === 'asc' ? ' ↑' : ' ↓';
  };

  const toggleTipo = (v) => {
    setFiltroTipos(s => {
      const novo = new Set(s);
      novo.has(v) ? novo.delete(v) : novo.add(v);
      return novo;
    });
  };
  const toggleEtapa = (v) => {
    // Marcar a etapa "F" desliga o filtro Fechados Período (e vice-versa)
    if (v === 'F' && !filtroEtapas.has('F') && filtroFechadosPeriodo) {
      setFiltroFechadosPeriodo(false);
      setListaFechadosPeriodo([]);
    }
    setFiltroEtapas(s => {
      const novo = new Set(s);
      novo.has(v) ? novo.delete(v) : novo.add(v);
      return novo;
    });
  };

  const toggleTemp = (v) => {
    setFiltroTemps(s => {
      const novo = new Set(s);
      novo.has(v) ? novo.delete(v) : novo.add(v);
      return novo;
    });
  };

  // Marcar "Fechados Período" → desmarca check "Fechado" e abre dialog do mês
  const toggleFechadosPeriodo = () => {
    if (filtroFechadosPeriodo) {
      // Estava ligado → desliga
      setFiltroFechadosPeriodo(false);
      setListaFechadosPeriodo([]);
    } else {
      // Liga → desmarca etapa F + abre dialog
      setFiltroEtapas(s => {
        const novo = new Set(s);
        novo.delete('F');
        return novo;
      });
      setFiltroFechadosPeriodo(true);
      setDialogPeriodoAberto(true);
    }
  };

  // ═══════ DASH ════════════════════════════════════════════════════════════
  // Helper: retorna o valor a exibir/somar pra um negócio.
  //   - Filtro "Fechados Período" ativo → soma das parcelas do mês
  //   - Senão, valor_atual (se preenchido) ou valor_previsto
  const valorExibido = (n) => {
    if (filtroFechadosPeriodo && n.soma_parcelas_mes != null) {
      return parseFloat(n.soma_parcelas_mes) || 0;
    }
    const atual = parseFloat(n.valor_atual);
    if (!isNaN(atual) && atual > 0) return atual;
    return parseFloat(n.valor_previsto) || 0;
  };

  const dashPorEtapa = ETAPAS_COM.map(e => {
    const itens = listaFiltrada.filter(n => n.etapa_comercial === e.v);
    const soma  = itens.reduce((acc, n) => acc + valorExibido(n), 0);
    return { etapa: e, qtd: itens.length, soma };
  });
  const totalQtd  = listaFiltrada.length;
  const totalSoma = listaFiltrada.reduce((acc, n) => acc + valorExibido(n), 0);

  // ═══════ AÇÕES DO PAINEL ═════════════════════════════════════════════════
  const abrirPainel = async (modo, registro = null) => {
    await carregarCombos();

    // Limpa estados das seções (evita dados do negócio anterior aparecerem)
    setParticipantes([]); setParticipantesCliente([]);
    setAnexos([]); setAditivosVinculados([]);
    setEventosTimeline([]);
    setFormNovoPart({ nome: '', email: '' });
    setMostrarFormPart(false); setMostrarSelectExistente(false);
    setErroPart(''); setErroAnexo('');
    setMostrarFormAnexo(false); setArquivoSelecionado(null);
    setDescricaoAnexo(''); setExibirTimeline(true);

    // Define quais seções abrir conforme o modo:
    //   - Inclusão: tudo expandido pra preencher de uma vez
    //   - Edição/Visualização: só Identif + Etapas + Timeline (resto colapsado)
    if (modo === 'novo') {
      setSecoes({
        identif: true, etapas: true, origem: true, participantes: true,
        anexos: true, valores: true, obs: true, timeline: true,
      });
    } else {
      setSecoes({
        identif: true, etapas: true, origem: false, participantes: false,
        anexos: false, valores: false, obs: false, timeline: true,
      });
    }

    if (modo === 'novo') {
      const hoje = hojeISO();
      setForm({
        ...FORM_VAZIO,
        dt_oportunidade: hoje,
        dt_levantamento: hoje,
        dt_proposta:     hoje,
      });
      setSelecionado(null);
      setEtapaOriginalDoBanco('');
      setNegociosAditivo([]);
    } else {
      // Recarrega o registro com usuario_id pra obter a flag pode_acessar_quantificacao
      let registroCompleto = registro;
      try {
        registroCompleto = await negocioService.buscarPorId(registro.id, usuarioLogadoId);
      } catch (err) {
        console.error('Aviso: falha ao recarregar negócio com permissões:', err);
        // Mantém o registro original se falhar (sem flag de permissão)
      }

      setForm(sanitizar({ ...FORM_VAZIO, ...registroCompleto }));
      setSelecionado(registroCompleto);
      setEtapaOriginalDoBanco(registroCompleto.etapa_comercial || '');

      // Pré-carrega os possíveis Negócios de Origem do cliente (combo sempre visível)
      if (registroCompleto.cliente_id) {
        try {
          const lista = await negocioService.listarParaAditivo(registroCompleto.cliente_id, registroCompleto.id);
          setNegociosAditivo(lista);
        } catch { setNegociosAditivo([]); }
      } else {
        setNegociosAditivo([]);
      }

      // Carrega aditivos vinculados pra mostrar como links
      setAditivosVinculados(calcularAditivosVinculados(registroCompleto, negocios));

      // Carrega participantes vinculados e do cliente
      try {
        const [vinc, todos] = await Promise.all([
          clienteParticipanteService.listarPorNegocio(registroCompleto.id),
          registroCompleto.cliente_id
            ? clienteParticipanteService.listarPorCliente(registroCompleto.cliente_id, registroCompleto.id)
            : Promise.resolve([]),
        ]);
        setParticipantes(vinc);
        setParticipantesCliente(todos);
      } catch (err) {
        console.error('Erro ao carregar participantes:', err);
      }

      // Carrega anexos
      try {
        const list = await negocioAnexoService.listar(registroCompleto.id);
        setAnexos(list);
      } catch (err) {
        console.error('Erro ao carregar anexos:', err);
      }

      // Carrega eventos da timeline
      try {
        const evs = await negocioEventoService.listar(registroCompleto.id);
        setEventosTimeline(evs);
      } catch (err) {
        console.error('Erro ao carregar eventos timeline:', err);
      }
    }
    setErroPainel(''); setSucessoPainel('');
    setPainel(modo);
  };

  const fecharPainel = () => {
    setPainel(null); setSelecionado(null);
    setNegociosAditivo([]); setAditivosVinculados([]);
    setParticipantes([]); setParticipantesCliente([]); setAnexos([]);
    setEtapaOriginalDoBanco('');
  };

  const handleCampo = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleCodigo = (e) => {
    let v = e.target.value.toUpperCase();
    v = v.replace(/[^A-Z0-9-]/g, '');
    if (v.length > 8) v = v.slice(0, 8);
    setForm(f => ({ ...f, id: v }));
  };

  // Quando muda o cliente, recarrega combos dependentes (aditivos + participantes)
  const handleCliente = async (id, nome) => {
    setForm(f => ({
      ...f,
      cliente_id:   id,
      cliente_nome: nome || '',
      id_original:  '',
    }));

    // Recarrega os possíveis Negócios de Origem do cliente (combo sempre visível)
    if (id) {
      try {
        const lista = await negocioService.listarParaAditivo(id, selecionado?.id);
        setNegociosAditivo(lista);
      } catch { setNegociosAditivo([]); }
    } else {
      setNegociosAditivo([]);
    }

    // Recarrega participantes do cliente (se está editando um negócio existente)
    if (id && selecionado?.id) {
      try {
        const todos = await clienteParticipanteService.listarPorCliente(id, selecionado.id);
        setParticipantesCliente(todos);
      } catch { setParticipantesCliente([]); }
    } else {
      setParticipantesCliente([]);
    }
  };

  // BUG FIX do item 1 — quando muda escopo pra Aditivo, recarrega combo
  // usando o cliente_id MAIS RECENTE (não o do closure). Também aceita
  // que o usuário escolha Aditivo antes do cliente e já prepara a UI.
  const handleEscopo = async (e) => {
    const novoEscopo = e.target.value;
    setForm(f => ({
      ...f,
      escopo: novoEscopo,
      id_original: novoEscopo === 'O' ? '' : f.id_original,
    }));

    if (novoEscopo === 'A') {
      // Usa o cliente_id do state atual (do form) através do callback
      const clienteAtual = form.cliente_id;
      if (clienteAtual) {
        try {
          const lista = await negocioService.listarParaAditivo(clienteAtual, selecionado?.id);
          setNegociosAditivo(lista);
        } catch { setNegociosAditivo([]); }
      } else {
        setNegociosAditivo([]);
      }
    } else {
      setNegociosAditivo([]);
    }
  };

  const abrirMenu = (e, tipo, negocio) => {
    e.stopPropagation();
    if (tipo === 'etapa' && negocio.etapa_comercial === 'F') return;
    const rect = e.currentTarget.getBoundingClientRect();
    const valorAtual = tipo === 'etapa' ? negocio.etapa_comercial : negocio.temperatura;
    setMenuAberto({
      tipo, negocioId: negocio.id, valorAtual,
      posicao: { top: rect.bottom + 4, left: rect.left },
    });
  };

  const escolherValor = async (novoValor) => {
    const { tipo, negocioId, valorAtual } = menuAberto;
    if (!negocioId || novoValor === valorAtual) return;
    try {
      if (tipo === 'etapa') {
        await negocioService.alterarEtapa(negocioId, novoValor);
      } else {
        await negocioService.alterarTemperatura(negocioId, novoValor);
      }
      await carregar();
    } catch (err) {
      alert(err.response?.data?.mensagem || 'Erro ao atualizar.');
    }
  };

  const fecharMenu = () => setMenuAberto({ tipo: null, negocioId: null, valorAtual: null, posicao: null });

  // ═══════ NAVEGAÇÃO ENTRE NEGÓCIOS VINCULADOS ═════════════════════════════
  // Clica num link de aditivo → abre aquele negócio no lugar
  const abrirNegocioVinculado = async (id) => {
    // Se for o mesmo, ignora
    if (id === selecionado?.id) return;
    const outro = negocios.find(n => n.id === id);
    if (!outro) {
      alert('Negócio não encontrado. Recarregue a lista.');
      return;
    }
    // Abre o outro no mesmo modo
    await abrirPainel(painel === 'editar' ? 'editar' : 'visualizar', outro);
  };

  // ═══════ AÇÕES DE PARTICIPANTES ══════════════════════════════════════════
  const adicionarParticipanteNovo = async () => {
    setErroPart('');
    if (!formNovoPart.nome.trim())  return setErroPart('Nome é obrigatório.');
    if (!emailValido(formNovoPart.email)) return setErroPart('E-mail inválido.');
    if (!form.cliente_id)           return setErroPart('Selecione um cliente primeiro.');
    if (!selecionado?.id)           return setErroPart('Salve o negócio antes de adicionar participantes.');

    try {
      await clienteParticipanteService.incluir(form.cliente_id, {
        nome: formNovoPart.nome,
        email: formNovoPart.email,
        negocio_id: selecionado.id,
      });
      // Recarrega as listas
      const [vinc, todos] = await Promise.all([
        clienteParticipanteService.listarPorNegocio(selecionado.id),
        clienteParticipanteService.listarPorCliente(form.cliente_id, selecionado.id),
      ]);
      setParticipantes(vinc);
      setParticipantesCliente(todos);
      setFormNovoPart({ nome: '', email: '' });
      setMostrarFormPart(false);
    } catch (err) {
      setErroPart(err.response?.data?.mensagem || 'Erro ao adicionar participante.');
    }
  };

  const vincularExistente = async (participanteId) => {
    if (!selecionado?.id) return;
    try {
      await clienteParticipanteService.vincular(selecionado.id, participanteId);
      const [vinc, todos] = await Promise.all([
        clienteParticipanteService.listarPorNegocio(selecionado.id),
        clienteParticipanteService.listarPorCliente(form.cliente_id, selecionado.id),
      ]);
      setParticipantes(vinc);
      setParticipantesCliente(todos);
      setMostrarSelectExistente(false);
    } catch (err) {
      alert(err.response?.data?.mensagem || 'Erro ao vincular.');
    }
  };

  const desvincularParticipante = async (participanteId) => {
    if (!selecionado?.id) return;
    if (!window.confirm('Remover este participante do negócio? (o cadastro do cliente é mantido)')) return;
    try {
      await clienteParticipanteService.desvincular(selecionado.id, participanteId);
      const [vinc, todos] = await Promise.all([
        clienteParticipanteService.listarPorNegocio(selecionado.id),
        clienteParticipanteService.listarPorCliente(form.cliente_id, selecionado.id),
      ]);
      setParticipantes(vinc);
      setParticipantesCliente(todos);
    } catch (err) {
      alert(err.response?.data?.mensagem || 'Erro ao remover participante.');
    }
  };

  // Participantes do cliente que AINDA não estão vinculados a este negócio
  const participantesNaoVinculados = participantesCliente.filter(
    p => !participantes.find(v => v.id === p.id)
  );

  // ═══════ AÇÕES DE ANEXOS ═════════════════════════════════════════════════
  // Fluxo em 2 passos:
  //   1. Usuário clica "Anexar arquivo" → escolhe o arquivo no picker
  //      → abre mini-form pedindo descrição + checkbox "exibir na timeline"
  //   2. Usuário confirma → faz upload com todos os dados
  const handleSelecionarArquivo = (e) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // permite re-selecionar o mesmo arquivo depois
    if (!file) return;
    if (!selecionado?.id) {
      setErroAnexo('Salve o negócio antes de anexar arquivos.');
      return;
    }
    setErroAnexo('');
    setArquivoSelecionado(file);
    setDescricaoAnexo(file.name);  // sugere o nome do arquivo como descrição inicial
    setExibirTimeline(true);
    setDataExibicaoAnexo(new Date().toISOString().slice(0, 10));  // default: hoje
    setMostrarFormAnexo(true);
  };

  const cancelarAnexo = () => {
    setMostrarFormAnexo(false);
    setArquivoSelecionado(null);
    setDescricaoAnexo('');
    setExibirTimeline(true);
    setDataExibicaoAnexo('');
    setErroAnexo('');
  };

  const confirmarUpload = async () => {
    setErroAnexo('');
    if (!arquivoSelecionado) return setErroAnexo('Nenhum arquivo selecionado.');
    if (!descricaoAnexo.trim()) return setErroAnexo('Descrição é obrigatória.');

    setUploadando(true);
    setProgressoUpload(0);
    try {
      const resp = await negocioAnexoService.upload(
        selecionado.id,
        arquivoSelecionado,
        descricaoAnexo.trim(),
        exibirTimeline,
        exibirTimeline ? dataExibicaoAnexo : '',
        setProgressoUpload,
      );
      const list = await negocioAnexoService.listar(selecionado.id);
      setAnexos(list);
      cancelarAnexo();

      // Recarrega timeline (anexo criou evento)
      try {
        const evs = await negocioEventoService.listar(selecionado.id);
        setEventosTimeline(evs);
      } catch {}

      // Se o backend sinalizou que deve sugerir mudança pra Levantamento
      // (DOS010 enviado em Oportunidade), abre o modal de Alterar Etapa
      if (resp?.sugerir_levantamento) {
        setTimeout(() => {
          setEtapaPreSelecionadaModal('L');
          setMotivoPreModal('Etapa alterada após inclusão de DOS010');
          setAnexoIdRecenteModal(resp?.anexo?.id || null);
          setAlterarEtapaModalAberto(true);
        }, 300);
      }

      // Se o anexo é um DOS010, pergunta:
      //   - Se NÃO existe quantificação ainda → "Deseja abrir a tela de Quantificação?"
      //   - Se JÁ existe quantificação → "Deseja gerar uma NOVA VERSÃO?"
      if (resp?.eh_dos010 && resp?.anexo) {
        setTimeout(async () => {
          // Verifica se já existe quantificação consultando as versões
          let jaExiste = false;
          try {
            const versoes = await negocioQuantificacaoService.listarVersoes(selecionado.id, usuarioLogadoId);
            jaExiste = Array.isArray(versoes) && versoes.length > 0;
          } catch (err) {
            // Se der 403 (sem permissão) ou outro erro, assume que não existe
            console.warn('Não conseguiu listar versões (provavelmente primeira vez):', err.message);
          }

          if (!jaExiste) {
            // Primeira quantificação — fluxo antigo
            if (window.confirm(
              'Documento DOS010 detectado!\n\n' +
              'Deseja abrir a tela de Quantificação da Proposta agora?'
            )) {
              setAnexoDos010Atual(resp.anexo);
              setQuantifModalAberto(true);
            }
          } else {
            // Já existe quantificação — pergunta se quer nova versão
            if (window.confirm(
              'Documento DOS010 detectado!\n\n' +
              'Já existe uma quantificação para este negócio.\n' +
              'Deseja gerar uma NOVA VERSÃO da quantificação a partir deste DOS010?\n\n' +
              '• Sim → cria nova versão e abre a tela de quantificação\n' +
              '• Não → apenas registra o anexo (sem nova versão)'
            )) {
              try {
                const nova = await negocioQuantificacaoService.criarNovaVersao(
                  selecionado.id,
                  { usuario_id: usuarioLogadoId, anexo_id: resp.anexo.id },
                );
                console.log('Nova versão criada:', nova?.versao);
                setAnexoDos010Atual(resp.anexo);
                setQuantifModalAberto(true);
                // Recarrega anexos pra mostrar a vinculação versao_quantificacao
                const list2 = await negocioAnexoService.listar(selecionado.id);
                setAnexos(list2);
                // Atualiza o negócio (versao mudou)
                const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
                setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
                setSelecionado(atualizado);
              } catch (err) {
                console.error('Erro ao criar nova versão:', err);
                alert('Erro ao criar nova versão: ' + (err.response?.data?.mensagem || err.message));
              }
            }
          }
        }, resp?.sugerir_levantamento ? 1500 : 300);
      }
    } catch (err) {
      setErroAnexo(err.response?.data?.mensagem || 'Erro no upload.');
    } finally {
      setUploadando(false);
      setProgressoUpload(0);
    }
  };

  // Clique num ícone da timeline — abre o recurso (anexo download, call link)
  const handleClickEventoTimeline = async (ev) => {
    if (ev.tipo_evento === 'Anexo' && ev.referencia_id) {
      // Busca o anexo na lista carregada
      const anexo = anexos.find(a => a.id === ev.referencia_id);
      if (anexo) {
        try {
          await negocioAnexoService.download(selecionado.id, anexo.id, anexo.nome_original);
        } catch {
          alert('Arquivo não disponível.');
        }
      } else {
        alert('Este anexo foi excluído ou não está mais disponível.');
      }
    } else if (ev.tipo_evento === 'Call' && ev.referencia_id) {
      // Busca a call pra pegar o link Teams
      try {
        const calls = await negocioCallService.listar(selecionado.id);
        const call = calls.find(c => c.id === ev.referencia_id);
        if (call?.link_teams) {
          window.open(call.link_teams, '_blank', 'noopener,noreferrer');
        } else {
          alert('Link da reunião não disponível.');
        }
      } catch {
        alert('Não foi possível abrir a reunião.');
      }
    }
    // Eventos de "Etapa: ..." não fazem nada no clique
  };

  const baixarAnexo = async (anexo) => {
    try {
      await negocioAnexoService.download(selecionado.id, anexo.id, anexo.nome_original);
    } catch (err) {
      alert('Erro ao baixar arquivo.');
    }
  };

  const excluirAnexo = async (anexo) => {
    if (!window.confirm(`Excluir o anexo "${anexo.descricao || anexo.nome_original}"?`)) return;

    // Se este DOS010 está vinculado à versão MAIOR de quantificação, pergunta
    // se também deve apagar a quantificação. Versões anteriores não são tocadas
    // (são histórico). Backend faz checagem de segurança independente.
    let excluirQuantificacao = false;
    if (anexo.eh_versao_maior && anexo.versao_quantificacao) {
      const respConfirm = window.confirm(
        `Este DOS010 gerou a quantificação v${anexo.versao_quantificacao}.\n\n` +
        `Deseja excluir TAMBÉM a quantificação v${anexo.versao_quantificacao}?\n\n` +
        `• OK → apaga o anexo E a quantificação. ` +
        `A versão ativa do negócio voltará para a anterior (ou v00 se era a única).\n` +
        `• Cancelar → apaga apenas o anexo. A quantificação fica preservada (sem o DOS010 de origem).`
      );
      excluirQuantificacao = respConfirm;
    }

    try {
      const resp = await negocioAnexoService.excluir(
        selecionado.id, anexo.id,
        { excluir_quantificacao: excluirQuantificacao }
      );
      const list = await negocioAnexoService.listar(selecionado.id);
      setAnexos(list);

      // Recarrega a timeline (o evento do anexo foi desativado no backend)
      try {
        const evs = await negocioEventoService.listar(selecionado.id);
        setEventosTimeline(evs);
      } catch {}

      // Se a quantificação foi apagada junto, recarrega o negócio (a versão mudou)
      if (resp?.quantificacao_apagada) {
        try {
          const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
          setSelecionado(atualizado);
          setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
        } catch (_) { /* ignore */ }
      }
    } catch (err) {
      alert(err.response?.data?.mensagem || 'Erro ao excluir.');
    }
  };

  // ═══════ STATUS BROWSE ═══════════════════════════════════════════════════
  const excluirNegocio = async (n) => {
    if (n.etapa_comercial !== 'O') return;
    if (!window.confirm(`Deseja excluir o negócio ${n.id}?\n\nEsta ação não pode ser desfeita.`)) return;
    try {
      await negocioService.excluir(n.id);
      await carregar();
    } catch (err) {
      alert(err.response?.data?.mensagem || 'Erro ao excluir negócio.');
    }
  };

  // ═══════ VALIDAR E SALVAR ════════════════════════════════════════════════
  const salvar = async () => {
    setErroPainel('');

    // Bloqueio: não permite salvar alteração se etapa atual = D (Perdido) ou F (Fechado)
    // Para reverter, o usuário deve usar o botão "Alterar etapa" e voltar pra etapa anterior
    if (painel === 'editar' && (form.etapa_comercial === 'D' || form.etapa_comercial === 'F')) {
      const nome = form.etapa_comercial === 'D' ? 'Perdido' : 'Fechado';
      return setErroPainel(
        `Negócios em etapa "${nome}" não podem ser alterados. ` +
        `Use o botão "🔄 Alterar" da etapa para reverter.`
      );
    }

    if (!form.id || !form.id.trim())
      return setErroPainel('Código do projeto é obrigatório.');
    if (!FORMATO_ID.test(form.id.trim()))
      return setErroPainel('Código deve estar no formato AAA-9999 (3 letras + hífen + 4 números).');

    if (!form.descricao.trim())     return setErroPainel('Descrição é obrigatória.');
    if (!form.tipo)                 return setErroPainel('Tipo é obrigatório.');
    if (!form.cliente_id)           return setErroPainel('Cliente é obrigatório.');
    if (!form.vendedor_id)          return setErroPainel('Vendedor é obrigatório.');

    if (!form.responsavel.trim())   return setErroPainel('Responsável é obrigatório.');
    if (!form.email_resp.trim())    return setErroPainel('E-mail do responsável é obrigatório.');
    if (!form.funcao_resp.trim())   return setErroPainel('Função do responsável é obrigatória.');

    if (!form.valor_previsto || numeroParaBackend(form.valor_previsto) <= 0)
      return setErroPainel('Valor Previsto deve ser maior que zero.');

    // Prepara payload com valor_previsto convertido pra número
    const formParaEnviar = {
      ...form,
      // Escopo derivado do Negócio de Origem: vazio → Original ('O'), preenchido → Aditivo ('A')
      escopo: form.id_original ? 'A' : 'O',
      valor_previsto: numeroParaBackend(form.valor_previsto),
    };

    setSalvando(true);
    // Fase 1: salva o negócio
    try {
      let idFinal = selecionado?.id;
      const ehInclusao = (painel === 'novo');
      if (ehInclusao) {
        const res = await negocioService.incluir(formParaEnviar);
        idFinal = res?.id;
      } else {
        await negocioService.alterar(selecionado.id, formParaEnviar);
      }
      setSucessoPainel(ehInclusao ? 'Negócio incluído com sucesso!' : 'Negócio alterado com sucesso!');
      await carregar();
      // Recarrega participantes e timeline porque o backend sincronizou
      // automaticamente vendedor + responsável
      if (idFinal && form.cliente_id) {
        try {
          const [vinc, todos, evs] = await Promise.all([
            clienteParticipanteService.listarPorNegocio(idFinal),
            clienteParticipanteService.listarPorCliente(form.cliente_id, idFinal),
            negocioEventoService.listar(idFinal).catch(() => []),
          ]);
          setParticipantes(vinc);
          setParticipantesCliente(todos);
          setEventosTimeline(evs);
        } catch (err) { /* ignora */ }
      }

      // ═══ INCLUSÃO DE NOVO ═══════════════════════════════════════════════════
      // Em vez de fechar o painel direto, abre o modal de data da oportunidade
      // (sem cancelar/ESC). Backend criou o negócio mas ainda NÃO criou o
      // evento "Etapa: Oportunidade" — quem vai criar é o definirDataOportunidade
      // chamado pelo modal com a data que o usuário escolher.
      if (ehInclusao && idFinal) {
        setNegocioRecemIncluido({
          id: idFinal,
          descricao: form?.descricao || '',
        });
        setDataOportunidadeModalAberto(true);
        // Não fecha o painel aqui — só fecha depois que a data for informada
      } else {
        setTimeout(fecharPainel, 1200);
      }
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || 'Erro ao salvar. Verifique os dados.');
    } finally {
      setSalvando(false);
    }
  };

  // Modo somente leitura:
  //   - Sempre quando o painel é 'visualizar'
  //   - Também quando o negócio está em F (Fechado): nesse caso só o botão
  //     "🔄 Alterar etapa" fica habilitado, todo o resto fica bloqueado
  const somenteLeitura = painel === 'visualizar'
                       || (painel === 'editar' && form.etapa_comercial === 'F');
  const toggleSec = (k) => setSecoes(s => ({ ...s, [k]: !s[k] }));
  const codigoEditavel = !somenteLeitura && (
    painel === 'novo' || etapaOriginalDoBanco === 'O'
  );

  // Negócio bloqueado pra edição normal: Fechado (F) ou Perdido (D)
  // No caso de Perdido, o usuário ainda pode usar o modal "Alterar etapa" pra voltar
  const negocioBloqueado = form.etapa_comercial === 'F' || form.etapa_comercial === 'D';

  // Se é modo "novo" (ainda sem id), participantes/anexos não dá pra usar
  const modoNovo = painel === 'novo';

  // ═══════ RENDER ════════════════════════════════════════════════════════════
  return (
    <div>

      {/* r110: BrowseHeader padronizado no topo */}
      <BrowseHeader
        rotina="crm"
        titulo="Negócios"
        descricao="Oportunidades e projetos comerciais com clientes, com etapas, propostas e ações de acompanhamento."
      />

      {/* ═══════════ VALORES POR STATUS (movido pro topo, compacto) ═══════════ */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap', overflowX: 'auto', marginBottom: '12px' }}>
        {dashPorEtapa.map(({ etapa, qtd, soma }) => (
          <div key={etapa.v} style={{
            flex: '1 1 0', minWidth: '112px',
            border: `1px solid ${etapa.cor}33`, borderRadius: '6px',
            padding: '6px 12px', backgroundColor: etapa.cor + '0d',
          }}>
            <div style={{
              fontSize: '10px', fontWeight: '700', color: etapa.cor,
              textTransform: 'uppercase', letterSpacing: '0.4px', whiteSpace: 'nowrap',
            }}>{etapa.l}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '8px', marginTop: '2px' }}>
              <span style={{ fontSize: '15px', fontWeight: '700', color: COR.texto }}>{String(qtd).padStart(2, '0')}</span>
              <span style={{ fontSize: '15px', fontWeight: '700', color: COR.texto, whiteSpace: 'nowrap' }}>{formatBRL(soma)}</span>
            </div>
          </div>
        ))}
        <div style={{
          flex: '1 1 0', minWidth: '112px',
          border: `2px solid ${COR.azul}`, borderRadius: '6px',
          padding: '6px 12px', backgroundColor: COR.azul, color: COR.branco,
        }}>
          <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Total</div>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '8px', marginTop: '2px' }}>
            <span style={{ fontSize: '15px', fontWeight: '700' }}>{String(totalQtd).padStart(2, '0')}</span>
            <span style={{ fontSize: '15px', fontWeight: '700', whiteSpace: 'nowrap' }}>{formatBRL(totalSoma)}</span>
          </div>
        </div>
      </div>

      {/* ═══════════ BROWSE ═══════════ */}
      <div style={{
        flex: 1, backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`, borderRadius: '8px',
        overflow: 'visible', minWidth: 0, marginBottom: '12px',
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${COR.borda}`,
          borderRadius: '8px 8px 0 0',
          display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: COR.muted }}>
            {listaFiltrada.length} de {negocios.length} registro{negocios.length !== 1 ? 's' : ''}
          </span>
          <input
            type="text" placeholder="Pesquisar..."
            value={busca} onChange={e => setBusca(e.target.value)}
            style={{ ...inputStyle, width: '260px' }}
          />
          <FiltroMultiplo titulo="Tipo" opcoes={TIPOS} selecionados={filtroTipos}
            onToggle={toggleTipo} getV={o => o.v} getL={o => o.l}
            onTodos={() => setFiltroTipos(filtroTipos.size === TIPOS.length ? new Set() : new Set(TIPOS.map(t => t.v)))} />
          <FiltroMultiplo titulo="Etapa" opcoes={ETAPAS_COM} selecionados={filtroEtapas}
            onToggle={toggleEtapa} getV={o => o.v} getL={o => o.l}
            getIcone={o => <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: o.cor }} />}
            onTodos={() => setFiltroEtapas(filtroEtapas.size === ETAPAS_COM.length ? new Set() : new Set(ETAPAS_COM.map(e => e.v)))}
            extra={(
              <>
                <label style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12px', color: COR.texto, padding: '4px 6px', cursor: 'pointer', userSelect: 'none', borderTop: `1px solid ${COR.borda}`, marginTop: '4px' }}>
                  <input type="checkbox" checked={filtroFechadosPeriodo} onChange={toggleFechadosPeriodo} style={{ cursor: 'pointer' }} />
                  <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1D9E75' }} />
                  <span style={{ fontWeight: '600' }}>Fechados Per.</span>
                </label>
                {filtroFechadosPeriodo && (
                  <div style={{ textAlign: 'center', marginTop: '2px' }}>
                    <span onClick={() => setDialogPeriodoAberto(true)} title="Clique pra alterar o período"
                      style={{ display: 'inline-block', fontSize: '11px', fontWeight: '600', color: '#1D9E75', cursor: 'pointer', padding: '3px 8px', backgroundColor: '#f0fff4', borderRadius: '4px', border: '1px solid #1D9E7555' }}>
                      📅 {mesAnoFechadosPeriodo}
                    </span>
                  </div>
                )}
              </>
            )} />
          <FiltroMultiplo titulo="Temp." opcoes={TEMPERATURAS} selecionados={filtroTemps}
            onToggle={toggleTemp} getV={o => o.v} getL={o => o.l}
            getIcone={o => <span>{o.icone}</span>}
            onTodos={() => setFiltroTemps(filtroTemps.size === TEMPERATURAS.length ? new Set() : new Set(TEMPERATURAS.map(t => t.v)))} />
          <div style={{ flex: 1 }} />
          <SePode rotina="crm" acao="incluir">
            <BtnIcone icone="incluir" onClick={() => abrirPainel('novo')} title="Incluir novo negócio" cor={COR.azul} solido tamanho="grande" />
          </SePode>
        </div>

        <div style={{ overflowX: 'auto', borderRadius: '0 0 8px 8px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: COR.azul }}>
                {/* r110: 1ª coluna fixa pro ícone SVG da rotina */}
                <th style={{ padding: '10px 14px', width: '36px' }}></th>
                {[
                  { label: 'Código',        campo: 'id'              },
                  { label: 'Tag',           campo: 'cliente_tag'     },
                  { label: 'Descrição',     campo: 'descricao'       },
                  { label: 'Tipo',          campo: 'tipo'            },
                  { label: 'Etapa',         campo: 'etapa_comercial' },
                  { label: 'Vendedor',      campo: 'vendedor_nome_amigavel' },
                  { label: 'Valor',         campo: 'valor_previsto'  },
                  { label: 'Última ação',   campo: 'dt_ultima_acao'  },
                  { label: 'Temp.',         campo: 'temperatura'     },
                  { label: 'Ações',         campo: null              },
                ].map(({ label, campo }) => (
                  <th key={label} onClick={() => campo && toggleOrdem(campo)} style={{
                    padding: '10px 14px', textAlign: 'left',
                    fontSize: '13px', fontWeight: '700', color: COR.branco,
                    whiteSpace: 'nowrap', cursor: campo ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {label}{campo && setaCabecalho(campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="11" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Carregando...</td></tr>
              ) : listaFiltrada.length === 0 ? (
                <tr><td colSpan="11" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Nenhum negócio encontrado.</td></tr>
              ) : listaFiltrada.map((n, i) => {
                const fechado = n.etapa_comercial === 'F';
                const podeExcluir = n.etapa_comercial === 'O';
                return (
                  <tr key={n.id} onClick={() => abrirPainel('visualizar', n)} style={{
                    borderBottom: `1px solid ${COR.borda}`,
                    backgroundColor: selecionado?.id === n.id ? COR.azulBg : i % 2 === 0 ? COR.branco : COR.cinzaBg,
                    cursor: 'pointer',
                  }}>
                    {/* r110: ícone SVG #003399 da rotina (mesmo do menu lateral) */}
                    <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle' }}>
                      {iconeDaRotina('crm', { width: 20, height: 20, color: COR.azul })}
                    </td>
                    <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>{n.id}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <TagCliente tag={n.cliente_tag} cor={n.cliente_cor_tag} />
                    </td>
                    <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>
                      {n.descricao}
                      {n.escopo === 'A' && (
                        <span style={{
                          fontSize: '12px', fontWeight: '500', color: COR.amarelo,
                          backgroundColor: COR.amlBg, padding: '2px 10px',
                          borderRadius: '20px', marginLeft: '6px',
                          border: `1px solid ${COR.amarelo}`,           // r110: borda
                        }}>ADITIVO</span>
                      )}
                    </td>
                    <td style={{ padding: '10px 14px', color: COR.muted }}>{labelTipo(n.tipo)}</td>
                    <td style={{ padding: '10px 14px' }} onClick={e => e.stopPropagation()}>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          // Mini-menu desativado — alteração só via modal.
                          // Pra negócios fechados, abre painel editar (somenteLeitura)
                          // pra que o usuário possa usar o botão "🔄 Alterar".
                          abrirPainel('editar', n);
                          setTimeout(() => setAlterarEtapaModalAberto(true), 200);
                        }}
                        title={n.etapa_comercial === 'F'
                          ? 'Negócio fechado — clique pra alterar etapa'
                          : 'Clique para alterar etapa via modal'}
                        style={{
                          display: 'inline-block',
                          cursor: 'pointer',
                        }}
                      >
                        <EtapaPill etapa={n.etapa_comercial} />
                      </div>
                    </td>
                    <td style={{ padding: '10px 14px', color: COR.muted }}>
                      {n.vendedor_nome_amigavel || n.vendedor_nome || '—'}
                    </td>
                    <td style={{ padding: '10px 14px', color: COR.texto, fontWeight: '500' }}>{formatBRL(valorExibido(n))}</td>
                    <td style={{ padding: '10px 14px' }}>
                      {(() => {
                        const dias = diasDesdeUltimaAcao(n.dt_ultima_acao);
                        const cores = corDiasUltimaAcao(dias);
                        const texto = dias === null ? '—' : `${dias}d`;
                        const titulo = dias === null
                          ? 'Nenhuma ação registrada'
                          : `Última ação há ${dias} dia${dias === 1 ? '' : 's'}`;
                        return (
                          <span title={titulo} style={{
                            display: 'inline-block',
                            padding: '2px 10px', borderRadius: '20px',
                            fontSize: '12px', fontWeight: '500',
                            backgroundColor: cores.bg, color: cores.cor,
                            border: `1px solid ${cores.cor}`,           // r110: borda na cor da fonte
                            minWidth: '32px', textAlign: 'center',
                          }}>{texto}</span>
                        );
                      })()}
                    </td>
                    <td style={{ padding: '10px 14px' }} onClick={e => e.stopPropagation()}>
                      <div
                        onClick={(e) => {
                          if (n.etapa_comercial === 'F' || n.etapa_comercial === 'D') return;
                          abrirMenu(e, 'temperatura', n);
                        }}
                        title={(n.etapa_comercial === 'F' || n.etapa_comercial === 'D')
                          ? 'Negócio bloqueado — temperatura não pode ser alterada'
                          : 'Clique para alterar'}
                        style={{
                          display: 'inline-block',
                          cursor: (n.etapa_comercial === 'F' || n.etapa_comercial === 'D')
                            ? 'not-allowed' : 'pointer',
                          opacity: (n.etapa_comercial === 'F' || n.etapa_comercial === 'D')
                            ? 0.5 : 1,
                        }}
                      >
                        <TemperaturaPill temp={n.temperatura} />
                      </div>
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <div style={{ display: 'flex', gap: '4px' }} onClick={e => e.stopPropagation()}>
                        <button
                          type="button"
                          onClick={() => {
                            setNegocioAcoes(n);
                            setAcoesModalAberto(true);
                          }}
                          title="Registrar/visualizar ações do CRM"
                          style={{
                            width: '28px', height: '28px',
                            border: `1px solid ${COR.azul}33`,
                            backgroundColor: COR.azul + '0d',
                            color: COR.azul, cursor: 'pointer',
                            borderRadius: '4px',
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                          }}
                        ><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="8" y="2" width="8" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><line x1="9" y1="12" x2="15" y2="12" /><line x1="9" y1="16" x2="13" y2="16" /></svg></button>
                        <SePode rotina="crm" acao="alterar">
                        <BtnIcone
                          icone="alterar"
                          onClick={() => abrirPainel('editar', n)}
                          title={n.etapa_comercial === 'F'
                            ? 'Editar — apenas alteração de etapa permitida'
                            : 'Alterar'}
                          cor={COR.azul}
                        />
                        </SePode>
                        {podeExcluir && (
                          <SePode rotina="crm" acao="excluir">
                          <BtnIcone
                            icone="excluir"
                            onClick={() => excluirNegocio(n)}
                            title="Excluir negócio"
                            cor={COR.vermelho}
                          />
                          </SePode>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mini-menu */}
      <MenuOpcoes
        aberto={!!menuAberto.tipo}
        opcoes={menuAberto.tipo === 'temperatura' ? TEMPERATURAS : ETAPAS_COM}
        valorAtual={menuAberto.valorAtual}
        posicao={menuAberto.posicao}
        onEscolher={escolherValor}
        onFechar={fecharMenu}
      />

      {/* ═══════════ MODAL DE CADASTRO ═══════════ */}
      <Modal
        aberto={!!painel}
        titulo={
          painel === 'novo'   ? 'Novo Negócio' :
          painel === 'editar' ? `Alterar Negócio ${selecionado?.id || ''}` :
                                `Visualizar Negócio ${selecionado?.id || ''}`
        }
        onFechar={fecharPainel}
        onSalvar={salvar}
        salvando={salvando}
        somenteLeitura={somenteLeitura}
        onEditar={() => setPainel('editar')}
        rotina="crm"
        descricao="Cadastro de negócios (CRM): identificação, participantes e anexos."
        botoesNoTopo
        botoesExtras={!modoNovo && selecionado?.id ? (
          <>
            <button type="button" onClick={() => setCallsModalAberto(true)} style={estiloBtnHeader}>
              <SvgCalendario size={15} /> Eventos
            </button>
            {selecionado?.pode_acessar_quantificacao && (
              <button type="button"
                onClick={() => { setAnexoDos010Atual(null); setQuantifModalAberto(true); }}
                style={estiloBtnHeader}>
                <SvgGrafico size={15} /> Quantificação
              </button>
            )}
          </>
        ) : null}
        largura="95vw"
      >
        <div style={{ fontFamily: "'Manrope', sans-serif" }}>

          {erroPainel && (
            <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
              {erroPainel}
            </div>
          )}
          {sucessoPainel && (
            <div style={{ backgroundColor: COR.verdeBg, border: `1px solid #a8e6c1`, borderRadius: '5px', color: '#1d6a3a', fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
              {sucessoPainel}
            </div>
          )}

          {/* ───────── 1. IDENTIFICAÇÃO ───────── */}
          <Secao icone={SvgIdentificacao} titulo="Identificação"
            aberta={secoes.identif} onToggle={() => toggleSec('identif')}>

            {/* L1: Código · Descrição · Versão · Tipo */}
            <div style={{ display: 'grid', gridTemplateColumns: '130px minmax(220px, 1.6fr) 80px 170px', gap: '18px' }}>
              <Campo label="Código (AAA-9999)" obrigatorio>
                <input
                  name="id" value={form.id} onChange={handleCodigo}
                  disabled={!codigoEditavel}
                  style={{
                    ...(codigoEditavel ? inputStyle : inputDisabledStyle),
                    textTransform: 'uppercase',
                    fontWeight: '700', letterSpacing: '0.5px',
                  }}
                  placeholder="ABC-1234" maxLength={8}
                />
              </Campo>
              <Campo label="Descrição" obrigatorio>
                <input name="descricao" value={form.descricao} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle}
                  placeholder="Ex: Implantação módulo financeiro" maxLength={100} />
              </Campo>
              <Campo label="Versão">
                <input value={form.versao} disabled style={inputDisabledStyle} />
              </Campo>
              <Campo label="Tipo" obrigatorio>
                <select name="tipo" value={form.tipo} onChange={handleCampo}
                  disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                  <option value="">Selecione...</option>
                  {TIPOS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
                </select>
              </Campo>
            </div>

            {/* L2: Cliente · Vendedor · Responsável Técnico */}
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(220px, 1.4fr) minmax(200px, 1fr) minmax(200px, 1fr)', gap: '18px', marginTop: '8px' }}>
              <Campo label="Cliente" obrigatorio>
                <ComboboxInline
                  valor={form.cliente_id}
                  labelAtual={form.cliente_nome
                    || clientes.find(c => c.id === form.cliente_id)?.nome_fantasia
                    || form.cliente_id}
                  rawAtual={clientes.find(c => c.id === form.cliente_id)
                    || (form.cliente_id ? { id: form.cliente_id, nome_fantasia: form.cliente_nome } : null)}
                  renderSelecionado={(c) => (
                    <>
                      {c?.tag && <TagCliente tag={c.tag} cor={c.cor_tag} />}
                      <span style={{ fontSize: '13px', color: COR.texto, flex: 1 }}>
                        {c?.nome_fantasia || c?.razao_social || form.cliente_nome}
                      </span>
                    </>
                  )}
                  buscar={(q) => clienteService.listarReferencia(q)}
                  getId={(c) => c.id}
                  getLabel={(c) => c.nome_fantasia || c.razao_social || c.id}
                  renderItem={(c) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {c.tag && <TagCliente tag={c.tag} cor={c.cor_tag} />}
                      <span style={{ color: COR.texto }}>{c.nome_fantasia || c.razao_social}</span>
                    </div>
                  )}
                  onSelecionar={(sel) => handleCliente(sel?.id || '', sel?.raw?.nome_fantasia || '')}
                  placeholder="Selecione o cliente..."
                  desabilitado={somenteLeitura}
                />
              </Campo>
              <Campo label="Vendedor" obrigatorio>
                <ComboboxInline
                  valor={form.vendedor_id}
                  labelAtual={form.vendedor_nome
                    || (() => { const v = vendedores.find(x => x.id === form.vendedor_id); return v ? (v.nome_amigavel || v.nome) : ''; })()
                    || form.vendedor_id}
                  buscar={(q) => colaboradorService.listarReferencia({ vendedor: true, q })}
                  getId={(v) => v.id}
                  getLabel={(v) => v.nome_amigavel || v.nome}
                  onSelecionar={(sel) => setForm(f => ({
                    ...f,
                    vendedor_id:   sel?.id || '',
                    vendedor_nome: sel?.raw?.nome || '',
                  }))}
                  placeholder="Selecione o vendedor..."
                  desabilitado={somenteLeitura}
                />
              </Campo>
              <Campo label="Responsável Técnico">
                <ComboboxInline
                  valor={form.resp_tecnico_id}
                  labelAtual={(() => {
                    const r = respTecnicos.find(x => x.id === form.resp_tecnico_id);
                    return r ? (r.nome_amigavel || r.nome) : (form.resp_tecnico_id || '');
                  })()}
                  buscar={(q) => colaboradorService.listarReferencia({ resp_tecnico: true, q })}
                  getId={(r) => r.id}
                  getLabel={(r) => r.nome_amigavel || r.nome}
                  onSelecionar={(sel) => setForm(f => ({ ...f, resp_tecnico_id: sel?.id || '' }))}
                  placeholder="— Sem resp. técnico —"
                  desabilitado={somenteLeitura}
                />
              </Campo>
            </div>

            {/* L3: Negócio de Origem · Valor Previsto · Etapa Atual */}
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(240px, 1fr) 160px 200px', gap: '18px', marginTop: '8px' }}>
              <Campo label="Negócio de Origem">
                {!form.cliente_id ? (
                  <div style={{
                    ...inputDisabledStyle, display: 'flex', alignItems: 'center',
                    color: COR.amarelo, fontSize: '11px',
                  }}>
                    Selecione o cliente primeiro
                  </div>
                ) : (
                  <select name="id_original" value={form.id_original} onChange={handleCampo}
                    disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="">— Original (sem vínculo) —</option>
                    {negociosAditivo.map(n => (
                      <option key={n.id} value={n.id}>{n.id} — {n.descricao} (v.{n.versao})</option>
                    ))}
                  </select>
                )}
              </Campo>
              {(() => {
                const editavelPorEtapa = form.etapa_comercial === 'O' || form.etapa_comercial === 'L';
                const labelValor = editavelPorEtapa ? 'Valor Previsto (R$)' : 'Valor Bruto (R$)';
                const desabilitado = somenteLeitura || !editavelPorEtapa;
                return (
                  <Campo label={labelValor} obrigatorio>
                    <input
                      type="text" name="valor_previsto" value={form.valor_previsto}
                      onChange={e => {
                        const formatado = centavosParaBR(e.target.value);
                        setForm(f => ({ ...f, valor_previsto: formatado }));
                      }}
                      disabled={desabilitado}
                      style={desabilitado
                        ? { ...inputDisabledStyle, textAlign: 'right' }
                        : { ...inputStyle, textAlign: 'right' }}
                      placeholder="0,00"
                    />
                  </Campo>
                );
              })()}
              <Campo label="Etapa Atual">
                <div style={{ display: 'flex', gap: '6px' }}>
                  <div style={{
                    flex: 1, height: '36px', padding: '0 10px',
                    border: `1px solid ${etapaCom(form.etapa_comercial).cor}`,
                    backgroundColor: etapaCom(form.etapa_comercial).cor + '22',
                    color: etapaCom(form.etapa_comercial).cor,
                    fontSize: '13px', fontWeight: '600', borderRadius: '5px',
                    display: 'flex', alignItems: 'center', overflow: 'hidden',
                    whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                  }}>
                    {etapaCom(form.etapa_comercial).l}
                  </div>
                  {!modoNovo && painel !== 'visualizar' && (
                    <button type="button" onClick={() => setAlterarEtapaModalAberto(true)}
                      title="Alterar etapa comercial"
                      style={{
                        height: '36px', padding: '0 10px', border: `1px solid ${COR.azul}`,
                        backgroundColor: COR.branco, color: COR.azul,
                        fontSize: '13px', fontWeight: '600', borderRadius: '5px',
                        cursor: 'pointer', whiteSpace: 'nowrap',
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      }}><SvgRefresh size={14} /></button>
                  )}
                </div>
              </Campo>
            </div>

            {/* L4 + L5: (Chamado · Solicitante / Função · Email) à esquerda,
                Observações à direita ocupando as 2 linhas */}
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1.5fr) minmax(280px, 0.9fr)', gap: '18px', marginTop: '8px', alignItems: 'stretch' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '150px minmax(180px, 1fr)', gap: '8px 18px', alignContent: 'start' }}>
                <Campo label="Chamado de Origem">
                  <input name="chamado" value={form.chamado} onChange={handleCampo}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="Ex: CHM-12345" maxLength={15} />
                </Campo>
                <Campo label="Solicitante Responsável" obrigatorio>
                  <input name="responsavel" value={form.responsavel} onChange={handleCampo}
                    disabled={somenteLeitura} style={inputStyle} maxLength={60} />
                </Campo>
                <Campo label="Função" obrigatorio>
                  <input name="funcao_resp" value={form.funcao_resp} onChange={handleCampo}
                    disabled={somenteLeitura} style={inputStyle} maxLength={30}
                    placeholder="Ex: Gerente de TI" />
                </Campo>
                <Campo label="Email" obrigatorio>
                  <input type="email" name="email_resp" value={form.email_resp} onChange={handleCampo}
                    disabled={somenteLeitura} style={inputStyle} maxLength={100}
                    placeholder="responsavel@cliente.com.br" />
                </Campo>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box', paddingBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '4px' }}>
                  Observações
                </label>
                <textarea name="observacoes" value={form.observacoes} onChange={handleCampo}
                  disabled={somenteLeitura}
                  style={{ ...textareaStyle, flex: 1, minHeight: '80px', resize: 'vertical' }}
                  placeholder="Histórico, próximos passos, contexto..." />
              </div>
            </div>

            {/* Aditivos vinculados — links clicáveis (informativo) */}
            {!modoNovo && aditivosVinculados.length > 0 && (
              <div style={{ marginTop: '4px' }}>
                <Campo label={form.escopo === 'O' ? '🔗 Aditivos deste projeto' : '🔗 Projeto Original e aditivos-irmãos'}>
                  <div style={{
                    padding: '8px 10px', border: `1px solid ${COR.borda}`, borderRadius: '5px',
                    backgroundColor: COR.cinzaBg, display: 'flex', flexWrap: 'wrap', gap: '6px',
                  }}>
                    {aditivosVinculados.map(n => (
                      <span key={n.id} onClick={() => abrirNegocioVinculado(n.id)}
                        title={`Abrir ${n.id} — ${n.descricao}`}
                        style={{
                          padding: '3px 10px',
                          backgroundColor: n.escopo === 'A' ? COR.amlBg : COR.azulBg,
                          color: n.escopo === 'A' ? COR.amarelo : COR.azul,
                          borderRadius: '20px', fontSize: '12px', fontWeight: '600',
                          cursor: 'pointer',
                          border: `1px solid ${n.escopo === 'A' ? '#f0c97a' : '#a8b8e6'}`,
                          textDecoration: 'underline',
                        }}>
                        {n.id} — {n.descricao}{n.escopo === 'O' && ' (original)'}
                      </span>
                    ))}
                  </div>
                </Campo>
              </div>
            )}
          </Secao>

          {/* Participantes + Anexos lado a lado (2 colunas) */}
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '12px', alignItems: 'start' }}>
          <Secao icone={SvgParticipantes} titulo="Participantes"
            aberta={secoes.participantes} onToggle={() => toggleSec('participantes')}>

            {modoNovo && (
              <div style={{
                backgroundColor: COR.amlBg, border: `1px solid #f0c97a`,
                borderRadius: '5px', padding: '10px 12px',
                color: COR.amarelo, fontSize: '12px', marginBottom: '10px',
              }}>
                ⚠️ Salve o negócio primeiro para poder adicionar participantes.
              </div>
            )}

            {!modoNovo && (
              <>
                {erroPart && (
                  <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '12px', padding: '8px 10px', marginBottom: '10px' }}>
                    {erroPart}
                  </div>
                )}

                {/* Grid de mini-cards */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                  gap: '8px', marginBottom: '10px',
                }}>
                  {participantes.map(p => {
                    const pi = papelInfo(p.papel, p.origem, p);
                    return (
                      <div key={p.id} style={{
                        border: `1px solid ${pi ? pi.cor : COR.borda}`,
                        borderLeft: pi ? `3px solid ${pi.cor}` : `1px solid ${COR.borda}`,
                        borderRadius: '6px',
                        padding: '8px 10px',
                        display: 'flex', alignItems: 'center', gap: '8px',
                        backgroundColor: pi ? pi.bg : COR.cinzaBg,
                      }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '12px', fontWeight: '600', color: COR.texto, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: '20px' }}>
                            {pi && <span style={{ marginRight: '4px' }}>{pi.emoji}</span>}
                            {p.nome}
                            {pi && (
                              <span style={{
                                display: 'inline-block',
                                fontSize: '9px', fontWeight: '700',
                                color: pi.cor, marginLeft: '6px',
                                padding: '2px 6px',
                                backgroundColor: COR.branco,
                                border: `1px solid ${pi.cor}`,
                                borderRadius: '8px',
                                verticalAlign: 'middle',
                                lineHeight: '1',
                                textTransform: 'uppercase', letterSpacing: '0.4px',
                              }}>{pi.label}</span>
                            )}
                          </div>
                          <div style={{ fontSize: '11px', color: COR.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: pi ? '4px' : '2px' }}>
                            {p.email}
                          </div>
                        </div>
                        {!somenteLeitura && (
                          <button
                            onClick={() => desvincularParticipante(p.id)}
                            title="Remover deste negócio"
                            style={{
                              border: 'none', background: 'transparent',
                              color: COR.vermelho, cursor: 'pointer',
                              fontSize: '16px', padding: '2px 6px',
                            }}
                          >×</button>
                        )}
                      </div>
                    );
                  })}
                  {participantes.length === 0 && (
                    <div style={{ fontSize: '12px', color: COR.muted, padding: '12px', gridColumn: '1 / -1', textAlign: 'center' }}>
                      Nenhum participante vinculado a este negócio ainda.
                    </div>
                  )}
                </div>

                {!somenteLeitura && (
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => { setMostrarFormPart(v => !v); setMostrarSelectExistente(false); }}
                      style={{
                        padding: '6px 12px', fontSize: '12px', fontWeight: '600',
                        border: `1px solid ${COR.azul}`, borderRadius: '5px',
                        backgroundColor: mostrarFormPart ? COR.azul : COR.branco,
                        color: mostrarFormPart ? COR.branco : COR.azul,
                        cursor: 'pointer',
                      }}
                    >+ Novo participante</button>

                    {participantesNaoVinculados.length > 0 && (
                      <button
                        onClick={() => { setMostrarSelectExistente(v => !v); setMostrarFormPart(false); }}
                        style={{
                          padding: '6px 12px', fontSize: '12px', fontWeight: '600',
                          border: `1px solid ${COR.verde}`, borderRadius: '5px',
                          backgroundColor: mostrarSelectExistente ? COR.verde : COR.branco,
                          color: mostrarSelectExistente ? COR.branco : COR.verde,
                          cursor: 'pointer',
                        }}
                      >+ Vincular existente ({participantesNaoVinculados.length})</button>
                    )}
                  </div>
                )}

                {/* Form de novo participante */}
                {mostrarFormPart && !somenteLeitura && (
                  <div style={{
                    marginTop: '10px', padding: '10px',
                    border: `1px solid ${COR.azul}`,
                    borderRadius: '6px', backgroundColor: COR.azulBg,
                  }}>
                    <Linha>
                      <Campo label="Nome" obrigatorio metade>
                        <input value={formNovoPart.nome}
                          onChange={e => setFormNovoPart(p => ({ ...p, nome: e.target.value }))}
                          style={inputStyle} placeholder="Nome completo" maxLength={100} />
                      </Campo>
                      <Campo label="E-mail" obrigatorio metade>
                        <input type="email" value={formNovoPart.email}
                          onChange={e => setFormNovoPart(p => ({ ...p, email: e.target.value }))}
                          style={inputStyle} placeholder="participante@cliente.com.br" maxLength={100} />
                      </Campo>
                    </Linha>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={adicionarParticipanteNovo} style={{
                        padding: '6px 12px', fontSize: '12px', fontWeight: '600',
                        border: 'none', borderRadius: '5px',
                        backgroundColor: COR.azul, color: COR.branco, cursor: 'pointer',
                      }}>Adicionar</button>
                      <button onClick={() => { setMostrarFormPart(false); setFormNovoPart({nome:'',email:''}); setErroPart(''); }}
                        style={{
                          padding: '6px 12px', fontSize: '12px',
                          border: `1px solid ${COR.borda}`, borderRadius: '5px',
                          backgroundColor: COR.branco, cursor: 'pointer',
                        }}>Cancelar</button>
                    </div>
                  </div>
                )}

                {/* Select de participantes já cadastrados no cliente */}
                {mostrarSelectExistente && !somenteLeitura && (
                  <div style={{
                    marginTop: '10px', padding: '10px',
                    border: `1px solid ${COR.verde}`,
                    borderRadius: '6px', backgroundColor: COR.verdeBg,
                  }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: COR.texto, marginBottom: '8px' }}>
                      Selecione um participante já cadastrado neste cliente:
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '6px' }}>
                      {participantesNaoVinculados.map(p => (
                        <div key={p.id}
                          onClick={() => vincularExistente(p.id)}
                          style={{
                            padding: '8px 10px',
                            border: `1px solid ${COR.borda}`,
                            borderRadius: '5px',
                            backgroundColor: COR.branco,
                            cursor: 'pointer',
                            transition: 'background-color 0.15s',
                          }}
                          onMouseEnter={e => e.currentTarget.style.backgroundColor = COR.verdeBg}
                          onMouseLeave={e => e.currentTarget.style.backgroundColor = COR.branco}
                        >
                          <div style={{ fontSize: '12px', fontWeight: '600', color: COR.texto }}>{p.nome}</div>
                          <div style={{ fontSize: '11px', color: COR.muted }}>{p.email}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </Secao>

          {/* ───────── 4. ANEXOS ───────── */}
          <Secao icone={SvgAnexos} titulo="Anexos"
            aberta={secoes.anexos} onToggle={() => toggleSec('anexos')}>

            {modoNovo && (
              <div style={{
                backgroundColor: COR.amlBg, border: `1px solid #f0c97a`,
                borderRadius: '5px', padding: '10px 12px',
                color: COR.amarelo, fontSize: '12px', marginBottom: '10px',
              }}>
                ⚠️ Salve o negócio primeiro para poder anexar arquivos.
              </div>
            )}

            {!modoNovo && (
              <>
                {erroAnexo && (
                  <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '12px', padding: '8px 10px', marginBottom: '10px' }}>
                    {erroAnexo}
                  </div>
                )}

                {/* Grid de mini-cards de anexos */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                  gap: '8px', marginBottom: '10px',
                }}>
                  {anexos.map(a => (
                    <div key={a.id} style={{
                      border: `1px solid ${COR.borda}`,
                      borderRadius: '6px',
                      padding: '8px 10px',
                      display: 'flex', alignItems: 'center', gap: '8px',
                      backgroundColor: COR.cinzaBg,
                    }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {/* Descrição em cima, destacada (igual aos participantes) */}
                        <div style={{
                          fontSize: '12px', fontWeight: '600', color: COR.texto,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}>
                          📄 {a.descricao || a.nome_original}
                          {a.exibir_timeline ? null : (
                            <span style={{
                              fontSize: '9px', fontWeight: '600', color: COR.muted,
                              backgroundColor: '#e0e0e0', padding: '1px 5px',
                              borderRadius: '8px', marginLeft: '6px',
                              verticalAlign: 'middle',
                            }}>OCULTO DA TIMELINE</span>
                          )}
                        </div>
                        {/* Nome físico + tamanho embaixo, menor */}
                        <div style={{
                          fontSize: '11px', color: COR.muted,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                          marginTop: '2px',
                        }}>
                          {a.nome_original} · {formatBytes(a.tamanho)}
                        </div>
                      </div>
                      <button
                        onClick={() => baixarAnexo(a)}
                        title="Baixar arquivo"
                        style={{
                          border: 'none', background: 'transparent',
                          color: COR.azul, cursor: 'pointer',
                          fontSize: '16px', padding: '2px 6px',
                        }}
                      >⬇</button>
                      {!somenteLeitura && (
                        <button
                          onClick={() => excluirAnexo(a)}
                          title="Excluir arquivo"
                          style={{
                            border: 'none', background: 'transparent',
                            color: COR.vermelho, cursor: 'pointer',
                            fontSize: '16px', padding: '2px 6px',
                          }}
                        >×</button>
                      )}
                    </div>
                  ))}
                  {anexos.length === 0 && !uploadando && !mostrarFormAnexo && (
                    <div style={{ fontSize: '12px', color: COR.muted, padding: '12px', gridColumn: '1 / -1', textAlign: 'center' }}>
                      Nenhum anexo ainda.
                    </div>
                  )}
                </div>

                {/* Botão pra iniciar fluxo de anexo (só se não está com form aberto) */}
                {!somenteLeitura && !mostrarFormAnexo && !uploadando && (
                  <label style={{
                    display: 'inline-block',
                    padding: '6px 12px', fontSize: '12px', fontWeight: '600',
                    border: `1px solid ${COR.azul}`, borderRadius: '5px',
                    backgroundColor: COR.branco, color: COR.azul,
                    cursor: 'pointer',
                  }}>
                    📎 Anexar arquivo
                    <input
                      type="file"
                      onChange={handleSelecionarArquivo}
                      style={{ display: 'none' }}
                      accept=".pdf,.docx,.xlsx,.html,.htm,.csv,.eml,.jpg,.jpeg,.png,.gif,.webp,.bmp"
                    />
                  </label>
                )}

                {/* Mini-form de descrição + checkbox, aparece depois de escolher o arquivo */}
                {mostrarFormAnexo && !somenteLeitura && (
                  <div style={{
                    marginTop: '4px', padding: '12px',
                    border: `1px solid ${COR.azul}`,
                    borderRadius: '6px', backgroundColor: COR.azulBg,
                  }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: COR.azul, marginBottom: '8px' }}>
                      📄 Arquivo: {arquivoSelecionado?.name} ({formatBytes(arquivoSelecionado?.size)})
                    </div>

                    <Campo label="Descrição do anexo" obrigatorio>
                      <input
                        value={descricaoAnexo}
                        onChange={e => setDescricaoAnexo(e.target.value)}
                        style={inputStyle}
                        placeholder="Ex: Proposta comercial v2, Planilha de custos, Ata da reunião..."
                        maxLength={255}
                        autoFocus
                      />
                    </Campo>

                    <label style={{
                      display: 'inline-flex', alignItems: 'center', gap: '8px',
                      fontSize: '13px', color: COR.texto,
                      padding: '8px 12px',
                      border: `1px solid ${exibirTimeline ? COR.azul : COR.borda}`,
                      backgroundColor: exibirTimeline ? COR.branco : COR.cinzaBg,
                      borderRadius: '5px',
                      userSelect: 'none', cursor: 'pointer',
                      marginBottom: '10px',
                    }}>
                      <input
                        type="checkbox"
                        checked={exibirTimeline}
                        onChange={e => setExibirTimeline(e.target.checked)}
                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                      />
                      <span style={{ fontWeight: exibirTimeline ? '600' : '400' }}>
                        Exibir na timeline do negócio
                      </span>
                    </label>

                    {exibirTimeline && (
                      <Campo label="Data de exibição na timeline">
                        <input
                          type="date"
                          value={dataExibicaoAnexo}
                          onChange={e => setDataExibicaoAnexo(e.target.value)}
                          style={inputStyle}
                        />
                      </Campo>
                    )}

                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button
                        onClick={confirmarUpload}
                        disabled={uploadando}
                        style={{
                          padding: '6px 14px', fontSize: '12px', fontWeight: '600',
                          border: 'none', borderRadius: '5px',
                          backgroundColor: COR.azul, color: COR.branco,
                          cursor: uploadando ? 'not-allowed' : 'pointer',
                          opacity: uploadando ? 0.6 : 1,
                        }}
                      >{uploadando ? 'Enviando...' : 'Anexar'}</button>
                      <button
                        onClick={cancelarAnexo}
                        disabled={uploadando}
                        style={{
                          padding: '6px 14px', fontSize: '12px',
                          border: `1px solid ${COR.borda}`, borderRadius: '5px',
                          backgroundColor: COR.branco, cursor: 'pointer',
                        }}
                      >Cancelar</button>
                    </div>
                  </div>
                )}

                {/* Barra de progresso (durante o upload) */}
                {uploadando && (
                  <div style={{
                    marginTop: '10px', padding: '8px 10px',
                    backgroundColor: COR.azulBg, borderRadius: '5px',
                    fontSize: '12px', color: COR.azul,
                  }}>
                    📤 Enviando... {progressoUpload}%
                    <div style={{
                      height: '4px', marginTop: '4px',
                      backgroundColor: '#d0d8ee', borderRadius: '2px', overflow: 'hidden',
                    }}>
                      <div style={{
                        height: '100%', width: `${progressoUpload}%`,
                        backgroundColor: COR.azul, transition: 'width 0.2s',
                      }} />
                    </div>
                  </div>
                )}

                <div style={{ fontSize: '11px', color: COR.muted, marginTop: '6px' }}>
                  Formatos aceitos: PDF, DOCX, XLSX, HTML, CSV, EML, JPG, PNG, GIF, WEBP, BMP · Máx. 50 MB
                </div>
              </>
            )}
          </Secao>
          </div>

          {/* ───────── 3. TIMELINE (só aparece em modo edição/visualização) ───────── */}
          {!modoNovo && (
            <Secao icone={SvgTimeline} titulo="Timeline de Eventos"
              aberta={secoes.timeline}
              onToggle={() => toggleSec('timeline')}>
              <Timeline eventos={eventosTimeline} onEventoClick={handleClickEventoTimeline} negocio={selecionado} />
            </Secao>
          )}

        </div>
      </Modal>

      {/* Modal de Calls (eventos do tipo call - Teams) */}
      <CallsModal
        aberto={callsModalAberto}
        negocio={selecionado}
        clienteId={form.cliente_id}
        usuarioId={usuarioLogadoId}
        dadosLancamento={selecionado?.id ? {
          cliente_id:        form.cliente_id,
          cliente_label:     form.cliente_nome,
          projeto_id:        selecionado.id,
          projeto_descricao: form.descricao,
          tipo_negocio:      form.tipo,
          chamado:           form.chamado,
        } : null}
        onFechar={async () => {
          setCallsModalAberto(false);
          // Ao fechar modal de calls, recarrega timeline (pois pode ter novos eventos)
          if (selecionado?.id) {
            try {
              const evs = await negocioEventoService.listar(selecionado.id);
              setEventosTimeline(evs);
            } catch {}
          }
        }}
      />

      {/* Modal de Quantificação do Projeto (proposta) */}
      <QuantificacaoModal
        aberto={quantifModalAberto}
        negocio={selecionado}
        anexoDos010={anexoDos010Atual}
        usuarioId={usuarioLogadoId}
        onFechar={() => {
          setQuantifModalAberto(false);
          setAnexoDos010Atual(null);
        }}
        onSucesso={async () => {
          // Recarrega o negócio: a quantificação atualiza valor_previsto,
          // valor_hora e pct_comissao no banco — frontend precisa refletir
          if (selecionado?.id) {
            try {
              const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
              setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
              setSelecionado(atualizado);
              await carregar();
            } catch (err) {
              console.error('Erro ao recarregar negócio após salvar quantificação:', err);
            }
          }
        }}
      />

      {/* Modal de Alteração de Etapa Comercial */}
      <AlterarEtapaModal
        aberto={alterarEtapaModalAberto}
        negocio={selecionado}
        usuarioId={usuarioLogadoId}
        etapaPreSelecionada={etapaPreSelecionadaModal}
        motivoPreenchido={motivoPreModal}
        anexoIdRecente={anexoIdRecenteModal}
        interceptarFechamento={true}
        onFechar={() => {
          setAlterarEtapaModalAberto(false);
          setEtapaPreSelecionadaModal(null);
          setMotivoPreModal('');
          setAnexoIdRecenteModal(null);
        }}
        onSucesso={async (novaEtapa, dadosEvento) => {
          // ═══ Avanço pra F: NÃO salva ainda; abre o FecharNegocioModal ═══
          if (novaEtapa === 'F' && dadosEvento?.direcao === 'avanco') {
            setDadosFechamentoEvento(dadosEvento);
            setAlterarEtapaModalAberto(false);
            setFecharModalAberto(true);
            return;
          }

          // Caso contrário (avanço normal pra outras etapas / retro / perdido):
          // recarrega o negócio
          if (selecionado?.id) {
            try {
              const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
              setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
              setSelecionado(atualizado);
              const evs = await negocioEventoService.listar(selecionado.id);
              setEventosTimeline(evs);
              await carregar();
            } catch (err) {
              console.error('Erro ao recarregar após alterar etapa:', err);
            }
          }
          setEtapaPreSelecionadaModal(null);
          setMotivoPreModal('');
          setAnexoIdRecenteModal(null);
        }}
      />

      {/* Modal de Fechamento de Negócio */}
      <FecharNegocioModal
        aberto={fecharModalAberto}
        negocio={selecionado}
        usuarioId={usuarioLogadoId}
        onFechar={() => {
          setFecharModalAberto(false);
          setDadosFechamentoEvento(null);
        }}
        onSucesso={async (dadosFechamento) => {
          // Agora SIM chama o backend pra alterar etapa pra F
          // mandando o fechamento completo no body
          await negocioService.alterarEtapaModal(selecionado.id, {
            nova_etapa: 'F',
            data_evento: dadosFechamentoEvento?.data_evento || new Date().toISOString().slice(0, 10),
            motivo: dadosFechamentoEvento?.motivo || 'Negócio fechado',
            usuario_id: usuarioLogadoId,
            fechamento: dadosFechamento,
          });
          setFecharModalAberto(false);
          setDadosFechamentoEvento(null);

          // Recarrega negócio
          if (selecionado?.id) {
            const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
            setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
            setSelecionado(atualizado);
            const evs = await negocioEventoService.listar(selecionado.id);
            setEventosTimeline(evs);
            await carregar();
          }
        }}
      />

      {/* Modal de Previsão Financeira (grid de parcelas) */}
      <PrevisaoFinanceiraModal
        aberto={previsaoModalAberto}
        negocio={selecionado}
        usuarioId={usuarioLogadoId}
        onFechar={() => setPrevisaoModalAberto(false)}
        onSucesso={async () => {
          if (selecionado?.id) {
            const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
            setSelecionado(atualizado);
          }
        }}
      />

      {/* Modal de Alteração de Etapa Técnica (reusa AlterarEtapaModal em modoTecnico) */}
      <AlterarEtapaModal
        aberto={etapaTecnicaModalAberto}
        negocio={selecionado}
        usuarioId={usuarioLogadoId}
        modoTecnico={true}
        onFechar={() => setEtapaTecnicaModalAberto(false)}
        onSucesso={async () => {
          if (selecionado?.id) {
            try {
              const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
              setForm(sanitizar({ ...FORM_VAZIO, ...atualizado }));
              setSelecionado(atualizado);
              const evs = await negocioEventoService.listar(selecionado.id);
              setEventosTimeline(evs);
              await carregar();
            } catch (err) {
              console.error('Erro ao recarregar após alterar etapa técnica:', err);
            }
          }
        }}
      />

      {/* Modal de Ações (CRM) */}
      <AcoesModal
        aberto={acoesModalAberto}
        negocio={negocioAcoes}
        usuario={usuarioLogado}
        onFechar={() => {
          setAcoesModalAberto(false);
          setNegocioAcoes(null);
        }}
        onSucesso={async () => {
          // Recarrega a lista pra refletir dt_ultima_acao atualizado
          await carregar();
          // Se o filtro Fechados Período estiver ativo, recarrega ele também
          if (filtroFechadosPeriodo) await carregarFechadosPeriodo();
          // Se o painel principal estiver aberto e for o mesmo negócio,
          // atualiza o form pra mostrar a nova data na seção Etapas
          if (selecionado?.id && negocioAcoes?.id === selecionado.id) {
            try {
              const atualizado = await negocioService.buscarPorId(selecionado.id, usuarioLogadoId);
              setSelecionado(atualizado);
              setForm(f => ({ ...f, dt_ultima_acao: atualizado.dt_ultima_acao || '' }));
            } catch (err) { /* ignore */ }
          }
        }}
      />

      {/* Modal de Data da Oportunidade (abre logo após inclusão de negócio).
          Sem botão fechar/cancelar — usuário precisa informar a data antes
          de prosseguir. Cria o evento "Etapa: Oportunidade" na timeline. */}
      <DefinirDataOportunidadeModal
        aberto={dataOportunidadeModalAberto}
        negocio={negocioRecemIncluido}
        usuarioId={usuarioLogadoId}
        onSucesso={async () => {
          setDataOportunidadeModalAberto(false);
          // Recarrega lista (pra refletir dt_oportunidade atualizada) e fecha o painel
          try {
            await carregar();
            if (negocioRecemIncluido?.id) {
              try {
                const evs = await negocioEventoService.listar(negocioRecemIncluido.id);
                setEventosTimeline(evs);
              } catch (_) { /* ignore */ }
            }
          } catch (_) { /* ignore */ }
          setNegocioRecemIncluido(null);
          fecharPainel();
        }}
      />

      {/* Modal de Seleção de Período (Fechados Período) */}
      {dialogPeriodoAberto && (
        <DialogPeriodo
          valor={mesAnoFechadosPeriodo}
          onCancelar={() => {
            setDialogPeriodoAberto(false);
            // Se o usuário cancelar e nunca confirmou um período, desliga o filtro
            if (listaFechadosPeriodo.length === 0) {
              setFiltroFechadosPeriodo(false);
            }
          }}
          onConfirmar={(novoMesAno) => {
            setMesAnoFechadosPeriodo(novoMesAno);
            setDialogPeriodoAberto(false);
          }}
        />
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// DialogPeriodo — Popup pra selecionar mês/ano (formato MM/AAAA)
// ════════════════════════════════════════════════════════════════════════════
function DialogPeriodo({ valor, onCancelar, onConfirmar }) {
  const [texto, setTexto] = useState(valor || '');
  const [erro, setErro]   = useState('');

  // Máscara: MM/AAAA — só dígitos, insere a barra automaticamente
  const aplicarMascara = (s) => {
    const dig = String(s).replace(/\D/g, '').slice(0, 6);
    if (dig.length <= 2) return dig;
    return `${dig.slice(0, 2)}/${dig.slice(2)}`;
  };

  const confirmar = () => {
    const m = texto.match(/^(\d{2})\/(\d{4})$/);
    if (!m) return setErro('Formato inválido. Use MM/AAAA (ex: 05/2026).');
    const mes = parseInt(m[1], 10);
    const ano = parseInt(m[2], 10);
    if (mes < 1 || mes > 12) return setErro('Mês inválido. Use 01 a 12.');
    if (ano < 2000 || ano > 2100) return setErro('Ano inválido.');
    onConfirmar(texto);
  };

  return (
    <>
      <div onClick={onCancelar} style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 10000,
      }} />
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%', maxWidth: '380px',
        backgroundColor: '#fff', borderRadius: '8px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        zIndex: 10001, overflow: 'hidden',
        fontFamily: "'Manrope', sans-serif",
      }}>
        <div style={{
          padding: '14px 18px', borderBottom: '1px solid #e8eaed',
          backgroundColor: '#003399', color: '#fff',
          display: 'flex', alignItems: 'center', gap: '10px',
        }}>
          <span style={{ fontSize: '18px' }}>📅</span>
          <span style={{ fontSize: '15px', fontWeight: '600', flex: 1 }}>
            Filtrar Fechados — Período
          </span>
          <button onClick={onCancelar} style={{
            border: 'none', background: 'transparent', color: '#fff',
            fontSize: '20px', cursor: 'pointer',
          }}>×</button>
        </div>
        <div style={{ padding: '20px 18px' }}>
          <label style={{
            display: 'block', fontSize: '11px', fontWeight: '600',
            color: '#888', marginBottom: '6px',
            textTransform: 'uppercase', letterSpacing: '0.5px',
          }}>
            Mês / Ano
          </label>
          <input
            type="text"
            value={texto}
            onChange={e => { setTexto(aplicarMascara(e.target.value)); setErro(''); }}
            placeholder="MM/AAAA"
            autoFocus
            onKeyDown={e => {
              if (e.key === 'Enter') confirmar();
              if (e.key === 'Escape') onCancelar();
            }}
            style={{
              width: '100%', height: '38px', padding: '0 12px',
              border: '1px solid #e8eaed', borderRadius: '5px',
              fontSize: '14px', boxSizing: 'border-box',
              outline: 'none',
            }}
          />
          {erro && (
            <div style={{
              marginTop: '8px', fontSize: '12px', color: '#e53935',
            }}>{erro}</div>
          )}
          <div style={{
            marginTop: '6px', fontSize: '11px', color: '#888',
          }}>
            Lista negócios em "Fechado" com parcelas vencendo no período selecionado.
          </div>
        </div>
        <div style={{
          padding: '12px 18px', borderTop: '1px solid #e8eaed',
          display: 'flex', gap: '8px', justifyContent: 'flex-end',
          backgroundColor: '#fafafa',
        }}>
          <button onClick={onCancelar} style={{
            padding: '8px 16px', fontSize: '13px', fontWeight: '600',
            border: '1px solid #e8eaed', borderRadius: '5px',
            backgroundColor: '#fff', color: '#1a1a2e',
            cursor: 'pointer',
          }}>Cancelar</button>
          <button onClick={confirmar} style={{
            padding: '8px 20px', fontSize: '13px', fontWeight: '600',
            border: 'none', borderRadius: '5px',
            backgroundColor: '#003399', color: '#fff',
            cursor: 'pointer',
          }}>Confirmar</button>
        </div>
      </div>
    </>
  );
}

export default NegociosPage;
